import * as util from 'util';
import _ from 'lodash';
import {Buffer} from 'safe-buffer';
import {RouteService} from "../../services/routeService";
import {NotificationService} from "../../services/notificationService";
import {GeneralService} from "../../services/generalService";
import {DICTIONARY} from "../../dictionary";
import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild
} from "@angular/core";
import {ClipboardService} from "ngx-clipboard";
import {eachLimit} from 'async';
import moment from "moment/moment";
import html2canvas from "html2canvas";
import {ENV_CONSTS} from "../../constants";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "../../services/authService";

const DEFAULT_AI_RESCAN = 'hybridNew';

@Component({
	selector: 'quarantined-email-action',
	templateUrl: './quarantined-email-action.component.html',
})

export class QuarantinedEmailActionComponent implements OnInit, OnChanges {

	@ViewChild('aiTrainingPreviewIframe') aiTrainingPreviewIframe: ElementRef;

	@Input('action') inputAction;
	@Input() email;
	@Input() data;
	@Input() planInfo;
	@Output() onActionDone = new EventEmitter<any>();
	@Output() viewEmailsFromSenderCb = new EventEmitter<string>();
	@Output() doneCb = new EventEmitter<void>();
	@Output() keyNavigateCb = new EventEmitter<number>();

	constructor(public gs:GeneralService,
				private ns:NotificationService,
				private rs:RouteService,
				private clipboard: ClipboardService,
				private http:HttpClient,
				private authService:AuthService) {
	}

	dic = DICTIONARY;
	_=_;
	// CC: node config supplied to echarts-graph (green=recipient, blue=sender)
	graphNodeCfg = {
		green: {
			color: '#2ecc71', label: 'Recipient', symbol: 'circle', icon: '\uf0e0',
			sizeMultiplier: 1,
		},
		blue: {
			color: '#4d8af0', label: 'Sender', symbol: 'circle', icon: '\uf007',
			sizeMultiplier: 1.3,
		},
	};

	// since we fire actions from inside and outside this whole component then we want to separate the active running action from the input one
	// in order to keep external inputs original when ngOnChanges is triggered
	runningAction;

	reviewerInfo = this.gs.reviewerInfo;
	userInfo;
	quarantineSubjectFilters = DICTIONARY.CONSTANTS.quarantineSubjectFilters;
	quarantineSubjectFiltersMatchEMDR;

	curTPResults;
	curEmail;
	curAction;
	loadQuarantineData;
	popupError;
	actionInProcess: boolean;
	showHtml;
	emailInfoPopup;
	isParentQuarantined;

	setCategoryPopup;
	mailboxRolePopup;
	isAdminUser;
	allowlistSenderPopup;
	blocklistSenderPopup;
	allowlistLinksPopup;
	showAuthSenderPopup;
	senderAuthMethod;
	senderAuthPhone;
	authSenderInProcess;
	blockSenderAuthRequest;
	urlTrackingPopup;
	openPreviewLinkPopup;
	previewAttachment;
	releaseQuarantinedEmailPopup;
	removeQuarantinedPopup;
	incidentPopup;
	securityReviewerPopup;
	releaseRejectPopup;
	requestReleasePopup;
	openAiClassifyEmailPopup;
	senderRowTargets: any = {};
	// CC: statuses the "Summarized Analysis" button is enabled for
	summarizedAnalysisStatuses = ['Spam', 'Malicious', 'Suspicious', 'Graymail'];
	openAiDatasetClasses = [
		{name: 'Safe', icon: 'fa-check-circle', color: 'var(--ui-success)'},
		{name: 'Spam', icon: 'fa-envelope', color: 'var(--ui-warning)'},
		{name: 'Graymail', icon: 'fa-inbox', color: 'var(--ui-text-muted)'},
		{name: 'Threat', icon: 'fa-bug', color: 'var(--ui-danger)'}
	];
	threatSimulationPopup;
	aiTrainingMaterialPopup;
	senderConnectionGraphPopup;

	addWarningLabel;
	addSubjectText;
	deleteRecord;
	addContactToAdmin;
	reportToTrustifi;
	blocklistSenderIdentity;
	removeFromBlocklist;
	setCategoryAsSafe;
	releaseAddSenderToAllowlist;
	releaseDefangUrl;

	securityTeamComments;
	threat_body_conf_precentages;
	spam_body_conf_precentages;
	graymail_body_conf_precentages;

	headerSearchTerm;
	reviewerSearchTerm;

	actionForHeaders = {
		senderEmail: false,
		senderEmailAppearsAs: false,
		senderDomain: false,
		replyToEmail: false,
		replyToDomain: false,
		returnPath: false,
		returnPathEmail: false,
		sendingMTA: false,
		sendingMTADomain: false,
		messageID: false,
	};

	statusPriority = {
		'Malicious': 1,
		'Suspicious': 2,
		'Spam': 3,
		'Graymail': 4,
		'Unsecured': 5,
		'External': 6,
		'Pending': 7,
		'Safe': 8
	};

	emailsSources = {
		trustifi: 'Trustifi',
		exchange: 'Microsoft Exchange'
	};

	aiTrainingAudienceOptions = [
		'All employees',
		'QA team',
		'R&D team',
		'IT department',
		'HR department',
		'Finance team',
		'Sales team',
		'Customer support',
		'Executives and management',
		'New employees / onboarding',
		'Remote workers',
		'Admins and privileged users',
	];

	ngOnInit() {
		this.gs.getUserInfo(false, (userInfo) => {
			this.userInfo = userInfo;
			this.isAdminUser = this.isDeleteActionAllowed();
		});
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes && this.inputAction) {
			if (this.planInfo?.tpMetrics && typeof this.planInfo.tpMetrics === 'object') {
				const tpMetrics = [];
				Object.keys(this.planInfo.tpMetrics || {}).forEach(key => {
					if (this.planInfo.tpMetrics[key]) {
						tpMetrics.push({sub_status: this.planInfo.tpMetrics[key].sub_status, description: this.planInfo.tpMetrics[key].description});
					}
				});
				this.planInfo.tpMetrics = tpMetrics;
			}

			this.runningAction = this.inputAction;
			this.handleAction();
		}
	}

	actionFinished() {
		if (this.emailInfoPopup?.show) {
			this.data = null;
			this.runningAction = this.dic.CONSTANTS.quarantinedActions.viewInfo;
			return;
		}

		this.doneCb.emit();
	}

	onThreatNavigate = (direction: number, event: Event) => {
		if (this.loadQuarantineData) {
			return;
		}
		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}
		this.keyNavigateCb.emit(direction);
	}

	handleAction = () => {
		const bulkEmails = this.data?.emails;
		if (!this.runningAction || (!this.email && !bulkEmails?.length)) {
			return;
		}

		switch (this.runningAction) {
			case this.dic.CONSTANTS.quarantinedActions.release.display:
				this.showReleaseQuarantinedEmailPopup(bulkEmails || [this.email]);
				break;

			case this.dic.CONSTANTS.quarantinedActions.remove.display:
				this.removeQuarantinedEmailPopup(bulkEmails || [this.email]);
				break;

			case this.dic.CONSTANTS.quarantinedActions.delete.display:
				this.deleteQuarantinedEmailPopup(bulkEmails || [this.email]);
				break;

			case this.dic.CONSTANTS.quarantinedActions.eml.display:
				this.downloadEml(this.email);
				break;

			case this.dic.CONSTANTS.quarantinedActions.setCategory.display:
				if (bulkEmails) {
					this.openSetMultipleCategoryPopup(bulkEmails);
				}
				else {
					this.openSetCategoryPopup(this.email);
				}
				break;

			case this.dic.CONSTANTS.quarantinedActions.blacklist.display:
				if (bulkEmails) {
					this.addMultipleSenderBlackListPopup(bulkEmails);
				}
				else {
					this.addSenderBlackListPopup(this.email);
				}
				break;

			case 'Do not preserve record':
				this.keepForeverPopup(bulkEmails || [this.email], false);
				break;

			case 'Preserve record':
				this.keepForeverPopup(bulkEmails || [this.email], true);
				break;

			case this.dic.CONSTANTS.quarantinedActions.trustSender.display:
				this.addContactToAdminPopup(bulkEmails || [this.email]);
				break;

			case this.dic.CONSTANTS.quarantinedActions.handled.display:
				if (bulkEmails) {
					const emailsCount = bulkEmails.length;
					this.setMultipleHandledStatus(bulkEmails, 0, true, () => {
						this.ns.showInfoMessage(`${emailsCount} emails were set as handled`);
					});
				}
				else {
					this.setHandledStatusExecute(this.email, !this.email.reviewed_completed, () => {});
				}
				break;

			case this.dic.CONSTANTS.quarantinedActions.viewInfo.display:
				this.viewQuarantineInfo(this.email);
				break;

			case this.dic.CONSTANTS.quarantinedActions.headers.display:
				this.previewQuarantinedEmailHeaders(this.email);
				break;

			case this.dic.CONSTANTS.quarantinedActions.whitelist.display:
				this.addSenderWhiteListPopup(this.email);
				break;

			case this.dic.CONSTANTS.quarantinedActions.linksWhitelist.display:
				this.addLinksWhitelistPopup(this.email);
				break;

			case this.dic.CONSTANTS.quarantinedActions.requestedReleaseReject.display:
				this.requestedReleaseRejectPopup(this.email);
				break;

			case this.dic.CONSTANTS.quarantinedActions.requestRelease.display:
				this.requestReleaseQuarantinedEmailPopup(this.email);
				break;

			case this.dic.CONSTANTS.quarantinedActions.authSender.display:
				this.authSenderPopup(this.email);
				break;

			case this.dic.CONSTANTS.quarantinedActions.signature.display:
				this.signaturePopup(this.email);
				break;

			case this.dic.CONSTANTS.quarantinedActions.removeSource.display:
				this.removeSourcePopup(this.email);
				break;

			case this.dic.CONSTANTS.quarantinedActions.allowFileType.display:
				this.allowBlockedFileType(this.email);
				break;

			case this.dic.CONSTANTS.quarantinedActions.rescan.display:
				this.openRescanEmailPopup(this.email);
				break;

			case this.dic.CONSTANTS.quarantinedActions.threatSimulationTemplate.display:
				this.openThreatSimulationTemplatePopup(this.email);
				break;

			case this.dic.CONSTANTS.quarantinedActions.aiTrainingMaterial.display:
				this.openAiTrainingMaterialPopup(this.email);
				break;

			case this.dic.CONSTANTS.quarantinedActions.createIncident.display:
				this.createIncidentPopup(this.email);
				break;

			case this.dic.CONSTANTS.quarantinedActions.securityReviewerActivity.display:
				this.createSecurityReviewerActivityPopup(this.email);
				break;

			case this.dic.CONSTANTS.quarantinedActions.classifyEmail.display:
				this.showOpenAiClassifyEmailPopup(this.email);
				break;

			case this.dic.CONSTANTS.quarantinedActions.AIanalysis.display:
				this.AIanalysisAction(this.email);
				break;

			case this.dic.CONSTANTS.quarantinedActions.review.display:
				this.previewQuarantinedEmailContent(this.email, 2, () => {});
				break;
		}
	}

	selectAction = (email, action) => {
		this.email = email;
		this.runningAction = action;
		this.handleAction();
	}

	getPlanIdParams = (email) => {
		const planId = getEmailPlanId(email);
		if (!this.gs.planAdmins?.length || !planId) {
			return {};
		}
		const adminObj = this.gs.planAdmins.find(itm => itm.alloc_plan_id?._id.toString() === planId);
		if (adminObj) {
			return {planId: planId};
		}
		return {};
	}

	getPlanIdParamsForQuarantineAction = (email) => {
		const planId = getEmailPlanId(email);
		if (!this.gs.planAdmins?.length || !planId) {
			return '';
		}

		if (this.userInfo?.plan?._id === planId) {
			return '';
		}

		const adminObj = this.gs.planAdmins.find(itm => itm.alloc_plan_id?._id.toString() === planId);
		if (adminObj) {
			return `?planId=${planId}`;
		}
		return '';
	}

	isDeleteActionAllowed = () => {
		return this.userInfo?.user_role === this.dic.CONSTANTS.userRole.admin ||
			this.userInfo?.user_role === this.dic.CONSTANTS.userRole.subAdmin;
	}

	closeQuarantinedPopup = () => {
		this.headerSearchTerm = '';
		this.reviewerSearchTerm = '';
		this.searchHeader();
		this.searchReviewer();
		this.emailInfoPopup.show = false;
		this.actionFinished();
	}

	viewEmailFromSender = () => {
		this.viewEmailsFromSenderCb.emit(this.curEmail.sender);
	}

	viewQuarantineInfo = (email) => {
		if (this.curEmail) {
			this.curEmail.content = null;
			this.curEmail.headers = null;
			this.curTPResults = null;
			this.curEmail.aiAnalysisData = null;
			this.curEmail.showAiAnalysis = false;
			this.curEmail.getAiAnalysisInProcess = false;
			this.curEmail.openAiDatasetPending = null;
		}

		this.curEmail = email;
		this.curEmail.allowSummarizedAnalysis = this.summarizedAnalysisStatuses.includes(this.curEmail.malicious?.status);

		if (this.curEmail.emails?.length) {
			this.curEmail.emails = _.sortBy(this.curEmail.emails, [(email) => {
				return email.category_priority || 0;
			}]);
			this.curEmail.visibleEmails = this.curEmail.emails.filter(childEmail => !childEmail.hide);
			this.curEmail.reviewer_actions = getFirstVisibleChild(this.curEmail).reviewer_actions;
		}

		this.showHtml = false;
		this.curEmail.isShowingContent = false;
		this.popupError = null;

		this.curEmail.showEmailTraceSection = moment().diff(moment(this.curEmail.created), 'days') <= 30;
		if (this.curEmail.showEmailTraceSection) {
			this.getEmailTrace();
		}

		this.previewQuarantinedEmailThreats(email);
	}

	previewQuarantinedEmailThreats = (email) => {
		this.emailInfoPopup = {
			show: true,
			category: this.curEmail.category
		};
		this.loadQuarantineData = true;
		const emailId = getEmailId(email);
		this.rs.getQuarantinedThreats(emailId, this.getPlanIdParams(email)).then((data) => {
			if (emailId === getEmailId(this.curEmail)) {
				this.curEmail._id = data._id;
				email.malicious = data.malicious;
				email.methods = data.methods;
				email.senderMethods = data.senderMethods;
				email.mailbox_email = email.mailbox_email || data.mailbox_email;
				this.showEmailThreatsPopup(email);
			}
			this.addReviewerAction(email, data.reviewerActivity);
			this.curEmail.curRecipient = this.curEmail.emails ? getFirstVisibleChild(this.curEmail) : this.curEmail;
			this.isParentQuarantined = this.curEmail.visibleEmails?.length > 1;
			this.loadQuarantineData = false;
		});
	}

	showEmailThreatsPopup = (email) => {
		this.curTPResults = email.malicious.tpResults;
		email.allowSummarizedAnalysis = this.summarizedAnalysisStatuses.includes(email.malicious.status);
		const tpFrom = this.curTPResults?.resHead?.from || {};
		// built once per email (not from the template) so the shield menus keep stable targets
		this.senderRowTargets = {
			appearsAs: this.rowTargets('email', tpFrom.senderMail),
			sender: this.rowTargets('sender', tpFrom.senderMailFrom),
			replyTo: this.rowTargets('email', tpFrom.replyTo),
			returnPath: this.rowTargets('email', tpFrom.returnPath),
			messageId: this.rowTargets('messageId', tpFrom.messageID),
			mta: this.rowTargets('mta', tpFrom.sendingMTAFull || tpFrom.sendingMTA?.domain, tpFrom.sendingMTA?.domain),
			ip: this.rowTargets('ip', tpFrom.ipAddresses)
		};
		if (this.curTPResults) {
			if (this.curTPResults.resHead && this.curTPResults.resHead.aiConfidence) {
				this.curTPResults.resHead.aiConfidence = parseFloat(this.curTPResults.resHead.aiConfidence.toFixed(2));
			}
			if (this.curTPResults.resUrl && this.curTPResults.resUrl.list && this.curTPResults.resUrl.list.length) {
				this.curTPResults.resUrl.list = this.curTPResults.resUrl.list.sort((a, b) => this.statusPriority[a.status] - this.statusPriority[b.status]);
				this.filterDuplicateSafeLinks();
			}
			else {
				if (!this.curTPResults.resUrl) {
					this.curTPResults.resUrl = {};
				}
				this.curTPResults.urlStatus = this.dic.CONSTANTS.threatProtection.status.safe;
				if (!this.curTPResults.resUrl.message) {
					this.curTPResults.resUrl.message = 'No malicious links detected.';
				}
			}
			if (this.curTPResults.resHash && this.curTPResults.resHash.list && this.curTPResults.resHash.list.length) {
				this.curTPResults.resHash.list = this.curTPResults.resHash.list.sort((a, b) => this.statusPriority[a.status] - this.statusPriority[b.status]);
			}
			else {
				if (!this.curTPResults.resHash) {
					this.curTPResults.resHash = {};
				}
				this.curTPResults.hashStatus = this.dic.CONSTANTS.threatProtection.status.safe;
				if (!this.curTPResults.resHash.message) {
					this.curTPResults.resHash.message = 'No malicious attachments detected.';
				}
			}

			if (this.planInfo?.tpMetrics?.length) {
				if (this.curTPResults?.resHead?.sub_status) {
					this.curTPResults.resHead.sub_status_description = this.planInfo?.tpMetrics.find(itm => itm.sub_status && itm.sub_status === this.curTPResults.resHead.sub_status)?.description || '';
				}
				if (this.curTPResults?.resUrl?.sub_status) {
					this.curTPResults.resUrl.sub_status_description = this.planInfo?.tpMetrics.find(itm => itm.sub_status && itm.sub_status === this.curTPResults.resUrl.sub_status)?.description || '';
				}
				if (this.curTPResults?.resHash?.sub_status) {
					this.curTPResults.resHash.sub_status_description = this.planInfo?.tpMetrics.find(itm => itm.sub_status && itm.sub_status === this.curTPResults.resHash.sub_status)?.description || '';
				}
			}

			if (this.curEmail.subject && this.reviewerInfo.is_security_reviewer) {
				const emailLowerCase = this.curEmail.subject.toLowerCase();
				const matchedFilter = this.quarantineSubjectFilters.find(subjectItm =>
					subjectItm.keywords.some(keywordItm =>
						(subjectItm.regex
								? new RegExp(keywordItm).test(emailLowerCase)
								: emailLowerCase.includes(keywordItm)
						)
					)
				);
				this.quarantineSubjectFiltersMatchEMDR = matchedFilter ? matchedFilter.name : null;
			}
		}
	}

	filterDuplicateSafeLinks = () => {
		let linksMap = {};
		this.curTPResults.resUrl.list = _.filter(this.curTPResults.resUrl.list, link => {
			if (link.name) {
				if (linksMap[link.name]) {
					if (link.status === this.dic.CONSTANTS.threatProtection.status.safe) {
						return false;
					}
				}
				else {
					if (link.status !== this.dic.CONSTANTS.threatProtection.status.safe) {
						linksMap[link.name] = link.url;
					}
					else {
						if (link.name === link.url &&
							_.find<any>(this.curTPResults.resUrl.list, l => l.status === this.dic.CONSTANTS.threatProtection.status.safe && l.name === link.name && l.url !== link.url)) {
							return false;
						}
					}
				}
			}
			return true;
		});
	}

	setInboundStatusStyles = (status) => {
		switch (status) {
			case this.dic.CONSTANTS.threatProtection.status.malicious:
				return {color: 'darkred', icon: 'fa-bug', loading: false};
			case this.dic.CONSTANTS.threatProtection.status.suspicious:
				return {color: 'darkred', icon: 'fa-bug', loading: false};
			case this.dic.CONSTANTS.threatProtection.status.error:
				return {color: 'darkred', icon: 'fa-exclamation-circle', loading: false};
			case this.dic.CONSTANTS.threatProtection.status.spam:
				return {color: 'darkorange', icon: 'fa-exclamation-circle', loading: false};
			case this.dic.CONSTANTS.threatProtection.status.grayMail:
				return {color: 'dimgray', icon: 'fa-exclamation-circle', loading: false};
			case this.dic.CONSTANTS.threatProtection.status.unsecured:
				return {color: 'darkorange', icon: 'fa-exclamation-circle', loading: false};
			case this.dic.CONSTANTS.threatProtection.status.pending:
			case this.dic.CONSTANTS.threatProtection.status.analyzing:
			case this.dic.CONSTANTS.threatProtection.status.analyzingLinks:
				return {color: 'darkorange', icon: 'fa-clock', loading: true};
			case this.dic.CONSTANTS.threatProtection.status.safe:
				return {color: 'darkgreen', icon: 'fa-check-circle', loading: false};
			case 'External':
				return {color: 'darkorange', icon: 'fa-external-link-alt', loading: false};
			default:
				return {color: 'darkorange', icon: 'fa-exclamation-circle', loading: false};
		}
	}

	getLinkTooltip = (url) => {
		let result = url.status;
		if (url.status !== this.dic.CONSTANTS.threatProtection.status.safe && url.name !== url.url) {
			result += '. This safe URL is hiding an unsafe link';
		}
		return result;
	}

	copyItemToClipboard = (item) => {
		this.clipboard.copy(item);
	}

	ipMatchesThreatAnalysisSendingMta = (from: { sendingMTAIP?: unknown } | undefined | null, listIp: unknown): boolean => {
		const mta = from?.sendingMTAIP;
		if (mta == null || mta === '') {
			return false;
		}
		return String(listIp).trim() === String(mta).trim();
	}

	threatAnalysisIpAddressesMtaFirst = (from: { ipAddresses?: unknown[]; sendingMTAIP?: unknown } | undefined | null): unknown[] => {
		const ips = from?.ipAddresses;
		if (!ips?.length) {
			return [];
		}
		const mta = from?.sendingMTAIP != null ? String(from.sendingMTAIP).trim() : '';
		if (!mta) {
			return [...ips];
		}
		const mtaNorm = mta.toLowerCase();
		const mtaFirst: unknown[] = [];
		const rest: unknown[] = [];
		for (const ip of ips) {
			if (String(ip).trim().toLowerCase() === mtaNorm) {
				mtaFirst.push(ip);
			} else {
				rest.push(ip);
			}
		}
		return [...mtaFirst, ...rest];
	}

	changeRecipientThreats = (recipient) => {
		this.curEmail.curRecipient = recipient;
		this.loadQuarantineData = true;
		this.rs.getQuarantinedThreats(recipient._id, this.getPlanIdParams(recipient)).then((data) => {
			if (data) {
				recipient.malicious = data.malicious;
				recipient.methods = data.methods;
				this.curEmail.methods = data.methods;
				this.curEmail.malicious = data.malicious;
				this.curEmail.status = data.status;
				this.curEmail.reason = data.reason;
				this.showEmailThreatsPopup(this.curEmail);
				this.setEmailCategory(data);
				this.emailInfoPopup.category = data.category;
				this.curEmail.reviewer_actions = recipient.reviewer_actions;
			}
			this.loadQuarantineData = false;
		});

		this.getEmailTrace();
	}

	previewQuarantinedEmailContent = (email, counter=2, cb) => {
		this.popupError = null;
		email.isShowingContent = true;
		if (email.content) {
			return cb();
		}

		email.loadingEmailContent = true;
		const emailId = email.curRecipient._id;
		this.rs.getQuarantinedEmailData(emailId, this.getPlanIdParams(email.curRecipient)).then((data) => {
			// Content must not gate arrow nav — only threats load uses loadQuarantineData.
			if (emailId !== getEmailId(this.curEmail?.curRecipient || this.curEmail)) {
				email.loadingEmailContent = false;
				return cb();
			}

			if (!data) {
				email.loadingEmailContent = false;
				return cb();
			}

			if (this.planInfo?.enableDefangeUrl) {
				if (data.content.html) {
					data.content.html = this.defangeUrlFromContent(data.content.html, true);
				}
				else {
					data.content.text = this.defangeUrlFromContent(data.content.text, false);
				}
			}

			const processedEmailContent = this.processEmailContent(data);
			email.content = {
				html: processedEmailContent,
				attachments: this.gs.getDownloadableEmailAttachments(data.content?.attachments)
			};
			this.addReviewerAction(this.curEmail, data.reviewerActivity);

			email.loadingEmailContent = false;
			cb();
		}, (err) => {
			if (emailId !== getEmailId(this.curEmail?.curRecipient || this.curEmail)) {
				email.loadingEmailContent = false;
				return cb();
			}

			if (err.data?.message && !err.data?.display_bar) {
				this.ns.showErrorMessage(err.data?.message);
			}
			if (err.data?.retry && counter > 0) {
				setTimeout(() => {
					this.previewQuarantinedEmailContent(email, --counter, cb);
				}, 1000);
			}
			else {
				email.loadingEmailContent = false;
				cb();
			}
		});
	}

	defangeUrlFromContent(content, isHtml) {
		const maliciousLinks = _.filter(this.curTPResults.resUrl.list, (url) => {
			return url.status === this.dic.CONSTANTS.threatProtection.status.malicious;
		}).map((maliciousUrl) => {
			return maliciousUrl.original_url || maliciousUrl.url;
		});

		if (maliciousLinks.length) {
			try {
				return isHtml ? this.gs.defangeMaliciousLinksFromHtml(content, maliciousLinks) : this.gs.defangeMaliciousLinksFromText(content, maliciousLinks);
			}
			catch (error) {
				return content;
			}
		} else {
			return content;
		}
	}

	processEmailContent(contentData) {
		let html = `<div>`;

		if (contentData.content) {
			if (contentData.content.from && contentData.content.from.text) {
				contentData.content.from.text = contentData.content.from.text.replaceAll('<', '(');
				contentData.content.from.text = contentData.content.from.text.replaceAll('>', ')');
				html += `<b>From:</b>  ${contentData.content.from.text}`;
			}

			if (contentData.content.to && contentData.content.to.text) {
				contentData.content.to.text = contentData.content.to.text.replaceAll('<', '(');
				contentData.content.to.text = contentData.content.to.text.replaceAll('>', ')');
				html += `<br><b>To:</b>  ${contentData.content.to.text}`;
			}
			if (contentData.content.cc && contentData.content.cc.text) {
				contentData.content.cc.text = contentData.content.cc.text.replaceAll('<', '(');
				contentData.content.cc.text = contentData.content.cc.text.replaceAll('>', ')');
				html += `<br><b>Cc:</b>  ${contentData.content.cc.text}`;
			}

			html += `<br><b>Subject:</b>  ${this.curEmail.subject}<br><hr><br></div>`;
			if (contentData.content.html) {
				html += contentData.content.html;
			}
			else if (contentData.content.text) {
				// plain-text emails: preserve newlines (Outlook-style) when injecting into HTML
				html += String(contentData.content.text)
					.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
					.replace(/\r\n?|\n/g, '<br>');
			}
		}

		return html;
	}

	previewQuarantinedEmailHeaders = (email, counter=2) => {
		if (this.curEmail.headers) {
			return;
		}
		this.curEmail.loadingHeaders = true;
		const emailId = getEmailId(email);
		this.rs.getQuarantinedEmailHeaders(emailId, this.getPlanIdParams(email)).then((data) => {
			if (emailId === getEmailId(this.curEmail)) {
				this.curEmail.headers = data.headers;
			}
			this.curEmail.loadingHeaders = false;
		}, (err) => {
			if (err.data?.message && !err.data?.display_bar) {
				this.ns.showErrorMessage(err.data?.message);
			}
			if (err.data?.retry && counter > 0) {
				setTimeout(() => {
					this.previewQuarantinedEmailHeaders(email, --counter);
				}, 1000);
			}
			else {
				this.curEmail.loadingHeaders = false;
			}
		});
	}

	previewLink = (url) => {
		if (!url) {
			this.openPreviewLinkPopup = null;
			return;
		}
		this.openPreviewLinkPopup = {
			show: true,
			url: url
		};
	}

	previewAttachmentFromEmail = (email, fileObj) => {
		if (!fileObj || !email || email.loadingEmailContent) {
			return;
		}
		this.previewQuarantinedEmailContent(email, 2, () => {
			this.previewAttachment = email.content?.attachments?.find(itm => itm.name === fileObj.name);
		});
	}

	downloadAttachment = (data, name, type) => {
		try {
			data = new Buffer(data, 'base64');
			this.gs.downloadData(data, name, type);
		} catch (err) {
			console.error(err);
		}
	}

	downloadEml = (emailObj) => {
		if (!emailObj) {
			return;
		}

		const data = {action: this.dic.CONSTANTS.quarantinedActions.eml.value};
		const emailId = getEmailId(emailObj);

		let doActionOnQuarantinedEmail;
		if (emailObj.source === this.emailsSources.exchange) {
			data['id'] = emailId;
			data['message_id'] = emailObj.message_id;
			data['subject'] = emailObj.subject;
			doActionOnQuarantinedEmail = this.rs.exchangeDoActionOnQuarantinedEmail(data).then(res => ({message: res.data}));
			this.ns.showInfoMessage('Fetching email data from Exchange, this action could take some time');
		}
		else {
			doActionOnQuarantinedEmail = this.doActionOnQuarantinedEmailRetry(emailId, data, this.getPlanIdParamsForQuarantineAction(emailObj));
		}

		doActionOnQuarantinedEmail.then((response) => {
			const attachment = {
				content: response.message,
				name: `${emailObj.subject}.eml`,
				contentType: 'message/rfc822'
			};
			this.gs.downloadData(attachment.content, attachment.name, attachment.contentType);
		}, err => {
			this.popupError = this.ns.getCurrentMessage();
		});
	}

	exportHeadersText = () => {
		if (!this.curEmail.headers) {
			this.ns.showWarnMessage(this.dic.ERRORS.noDataToExportCsv);
			return;
		}

		let csvString = "";
		this.curEmail.headers.forEach((header) => {
			if (!header.hide) {
				csvString += `${header.name || header.key}: ${header.value}\n`;
			}
		});

		this.gs.exportCsv(csvString, `quarantined_email_headers.txt`);
	}

	// CC: like exportHeadersText, copies only the headers currently shown (so an active search filter applies here too)
	copyAllHeaders = () => {
		let headersText = "";
		this.curEmail?.headers?.forEach((header) => {
			if (!header.hide) {
				headersText += `${header.name || header.key}: ${header.value}\n`;
			}
		});

		if (!headersText) {
			this.ns.showWarnMessage(this.dic.ERRORS.noDataToCopy);
			return;
		}

		this.gs.copyToClipboard(headersText, 'Headers');
	}

	addReviewerAction = (email, action) => {
		email.reviewed_completed = true;
		email.mark_follow = false;
		// CC: group flag is recomputed from its children on every list rebuild (search/regroup), so children must carry the handled value too
		email.emails?.forEach((emailObj) => {
			if (emailObj.hide) {
				return;
			}
			emailObj.reviewed_completed = true;
		});
		if (email.parent_id) {
			this.onActionDone.emit({action: 'markGroupParentReviewed', email});
		}
		if (!action) {
			return;
		}
		if (!email.reviewer_actions) {
			email.reviewer_actions = [];
		}

		const newAction = {
			created: new Date(),
			reviewer: this.reviewerInfo.email,
			action: action
		};
		email.reviewer_actions.unshift(newAction);
	}

	authenticateSender = () => {
		let actionData:any = {
			action: this.dic.CONSTANTS.quarantinedActions.authSender.value,
			authSenderMethod: this.senderAuthMethod
		};

		let notificationTxt = actionData.authSenderMethod;
		if (actionData.authSenderMethod === this.dic.CONSTANTS.authenticateSenderMethods.phone) {
			actionData.phone = this.senderAuthPhone;
			notificationTxt = 'SMS';
		}
		this.authSenderInProcess = true;
		this.loadQuarantineData = true;
		const emailId = getEmailId(this.curEmail);
		this.rs.doActionOnQuarantinedEmail(emailId, actionData, this.getPlanIdParamsForQuarantineAction(this.curEmail)).then((response) => {
			this.loadQuarantineData = false;
			this.curEmail.auth_sender = {
				updated: new Date(),
				method: this.senderAuthMethod
			};
			if (this.curEmail.auth_sender.method === this.dic.CONSTANTS.authenticateSenderMethods.phone) {
				this.curEmail.auth_sender.phone = this.senderAuthPhone;
			}

			this.authSenderInProcess = false;
			this.showAuthSenderPopup = false;
			this.actionFinished();
			this.addReviewerAction(this.curEmail, response.reviewerActivity);
			this.ns.showInfoMessage(util.format(this.dic.MESSAGES.quarantinedAuthSender, notificationTxt));
			this.popupError = this.ns.getCurrentMessage();
		}, err => {
			this.popupError = this.ns.getCurrentMessage();
			this.authSenderInProcess = false;
			this.loadQuarantineData = false;
		});
	}

	authSenderPopup = (email) => {
		this.curAction = this.dic.CONSTANTS.quarantinedActions.authSender.value;
		this.senderAuthMethod = this.dic.CONSTANTS.authenticateSenderMethods.phone;
		this.senderAuthPhone = {phone_number: '', country_code: ''};
		this.blockSenderAuthRequest = false;
		if (email.auth_sender && email.auth_sender.updated) {
			this.senderAuthMethod = email.auth_sender.method;
			if (email.auth_sender.method === this.dic.CONSTANTS.authenticateSenderMethods.phone) {
				this.senderAuthPhone = _.clone(email.auth_sender.phone);
			}
			email.auth_sender.minutes = this.gs.dateDiffInMinutes(new Date(email.auth_sender.updated), new Date());
			if (email.auth_sender.minutes <= this.dic.CONSTANTS.authSenderTtl) {
				this.blockSenderAuthRequest = true;
			}
		}
		this.curEmail = email;
		this.showAuthSenderPopup = true;
	}

	setMultipleHandledStatus = (emails, idx, enabled, cb) => {
		eachLimit(emails, 10, (emailObj, asyncCb) => {
			this.setHandledStatusExecute(emailObj, enabled, () => {
				asyncCb();
			});
		}, () => {
			cb();
		});
	}

	setHandledStatusExecute = (email, enabled, cb) => {
		if (!email) {
			cb();
			return;
		}
		// CC: taken from user-quarantined.component.ts -> setHandledStatusExecute
		if (email.parent) {
			this.setMultipleHandledStatus((email.emails || []).filter(childEmail => !childEmail.hide), 0, enabled, () => {
				email.reviewed_completed = enabled;
				cb();
			});
			return;
		}
		const data = {
			action: this.dic.CONSTANTS.quarantinedActions.handled.value,
			enabled: enabled
		};
		const emailId = getEmailId(email);
		this.loadQuarantineData = true;
		this.rs.doActionOnQuarantinedEmail(emailId, data, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
			this.addReviewerAction(email, `Set the email as ${data.enabled ? '' : 'not '}handled`);
			email.reviewed_completed = data.enabled;
			this.loadQuarantineData = false;
			cb();
		}, err => {
			this.popupError = this.ns.getCurrentMessage();
			cb();
		});
	}

	addContactToAdminPopup = (emails) => {
		if (!emails?.length) {
			return;
		}

		// CC: bulk selection is parent group rows; expand to real emails before uniq/trust/handled
		const flatEmails = _.flatMap(emails, (emailObj) => {
			return emailObj?.parent ? (emailObj.emails || []).filter((childEmail) => !childEmail.hide) : [emailObj];
		});
		if (!flatEmails.length) {
			return;
		}

		const sourceMismatchSubStatuses = ['Source Mismatch', 'Global Source Mismatch'];
		const emailsToTrust = [];
		const emailsToMarkHandled = [];
		const trustedSenders = new Set();

		flatEmails.forEach((emailObj) => {
			const subStatus = emailObj?.malicious?.tpResults?.resHead?.sub_status;
			// CC: Source/Global Source Mismatch must run per email (different sending sources)
			if (typeof subStatus === 'string' && sourceMismatchSubStatuses.includes(subStatus)) {
				emailsToTrust.push(emailObj);
				return;
			}

			const senderKey = emailObj.sender?.toLowerCase();
			if (!trustedSenders.has(senderKey)) {
				trustedSenders.add(senderKey);
				emailsToTrust.push(emailObj);
			}
			else {
				// CC: uniq-skipped rows still get set-handled so the checkmark persists after refresh
				emailsToMarkHandled.push(emailObj);
			}
		});

		const uniqueSenders = _.uniqBy(flatEmails, (emailObj) => emailObj.sender?.toLowerCase());
		let subTitle;
		if (uniqueSenders.length > 1) {
			subTitle = `Senders will be trusted for all users in the plan. Emails from trusted senders are less likely to be considered as spam, graymail, or BEC by the AI`;
		}
		else {
			subTitle = `Sender ${uniqueSenders[0].sender} will be trusted for all users in the plan. Emails from trusted senders are less likely to be considered as spam, graymail, or BEC by the AI`;
		}

		this.gs.showPopup({
			title: `Trust sender`,
			subTitle: subTitle,
			body: [],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Confirm',
			doneCb: () => {
				this.addMultipleContactToAdminExecute(emailsToTrust, 0, () => {
					this.setMultipleHandledStatus(emailsToMarkHandled, 0, true, () => {
						emails.forEach((emailObj) => {
							if (emailObj?.parent) {
								emailObj.reviewed_completed = !!emailObj.emails?.some((childEmail) => childEmail.reviewed_completed);
							}
						});
					});
				});
			}
		});
	}

	addMultipleContactToAdminExecute = (emails, idx, cb) => {
		eachLimit(emails, 10, (emailObj, asyncCb) => {
			this.addContactToAdminPopupExecute(emailObj, () => {
				asyncCb();
			});
		}, () => {
			cb();
		});
	}

	addContactToAdminPopupExecute = (email, cb) => {
		const data = {
			action: this.dic.CONSTANTS.quarantinedActions.trustSender.value
		};
		const emailId = getEmailId(email);
		this.doActionOnQuarantinedEmailRetry(emailId, data, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
			this.addReviewerAction(email, response.reviewerActivity);
			this.ns.showInfoMessage(`Operation completed successfully`);
			cb();
		}, err => {
			this.popupError = this.ns.getCurrentMessage();
			cb();
		});
	}

	keepForeverPopup = (emails, isEnabled) => {
		if (emails.length === 1) {
			const email = emails[0];
			let title, subTitle;
			if (isEnabled) {
				title = 'Preserve Quarantined Email Record';
				subTitle = `Please note - this email will not be automatically deleted after the ${this.planInfo?.rules[email.malicious.status.toLowerCase()].retention_period || 14}-day retention period.`;
			} else {
				title = 'Do Not Preserve Quarantined Email Record';
				subTitle = `Please note - this email will be automatically deleted after the ${this.planInfo?.rules[email.malicious.status.toLowerCase()].retention_period || 14}-day retention period.`;
			}

			this.gs.showPopup({
				title: title,
				subTitle: subTitle,
				body: [],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Confirm',
				doneCb: () => {
					this.keepForeverPopupExecute(email, isEnabled, () => {});
				}
			});
		}
		else {
			this.gs.showPopup({
				title: isEnabled ? 'Preserve Quarantined Email Records' : 'Do Not Preserve Quarantined Email Records',
				subTitle: isEnabled ? 'The selected emails will be kept in the system regardless the retention period' : 'Please note - the selected emails will be automatically deleted after the retention period defined in the plan policy',
				body: [],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Confirm',
				doneCb: () => {
					this.keepForeverPopupMultipleExecute(emails, isEnabled, 0, () => {});
				}
			});
		}
	}

	keepForeverPopupMultipleExecute = (emails, enabled, idx, cb) => {
		eachLimit(emails, 10, (emailObj, asyncCb) => {
			this.keepForeverPopupExecute(emailObj, enabled, () => {
				asyncCb();
			});
		}, () => {
			cb();
		});
	}

	keepForeverPopupExecute = (email, enabled, cb) => {
		const data = {
			action: this.dic.CONSTANTS.quarantinedActions.toggleKeepForever.value,
			enabled: enabled
		};
		const emailId = getEmailId(email);
		this.rs.doActionOnQuarantinedEmail(emailId, data, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
			email.keep_forever = enabled;
			// CC: group flag is recomputed from its children on every list rebuild, so children must carry the new value too
			email.emails?.forEach((emailObj) => {
				if (emailObj.hide) {
					return;
				}
				emailObj.keep_forever = enabled;
			});
			this.addReviewerAction(email, response.reviewerActivity);
			cb();
		});
	}

	openRescanEmailPopup = (email) => {
		this.gs.showPopup({
			title: 'Rescan Email',
			subTitle: "The process will only take a few moments to update the threat analysis scan results. Allow/Block lists will be ignored.",
			body: [],
			type: this.dic.CONSTANTS.popupInfo,
			doneBtnText: 'Rescan',
			doneCb: (options) => {
				const data:any = {action: this.dic.CONSTANTS.quarantinedActions.rescan.value};
				const emailId = getEmailId(email);
				this.rs.doActionOnQuarantinedEmail(emailId, data, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
					_.remove<any>(this.curEmail.methods, method => {
						return method === this.dic.CONSTANTS.quarantinedActions.rescan.value;
					});

					email.malicious.tpResults.rescan_in_process = true;
					this.checkViewThreatsReScanStatus(email);
					this.ns.showInfoMessage(this.dic.MESSAGES.operationCalled);
					this.addReviewerAction(email, response.reviewerActivity);
				}, err => {
					this.popupError = this.ns.getCurrentMessage();
				});
			}
		});
	}

	checkViewThreatsReScanStatus = (email, timeoutSeconds = 30) => {
		setTimeout(() => {
			const emailId = getEmailId(email);
			this.rs.getQuarantinedThreats(emailId, this.getPlanIdParams(email)).then((data) => {
				if (data.malicious.tpResults.rescan_in_process) {
					this.checkViewThreatsReScanStatus(email, timeoutSeconds);
				}
				else {
					email.malicious = data.malicious;
					this.setEmailCategoryExecute(email, email.malicious.status);
					this.showEmailThreatsPopup(email);
					if (this.emailInfoPopup) {
						this.emailInfoPopup.category = email.category;
					}
				}
			});
		}, timeoutSeconds * 1000);
	}

	openMailboxRolePopup = () => {
		this.mailboxRolePopup = {
			show: true,
			inProcess: false,
			email: this.curEmail?.curRecipient?.mailbox_email || this.curEmail?.mailbox_email?.toString(),
			name: this.curTPResults?.resHead?.recipientJobTitle || '',
			is_executive: !!this.curTPResults?.resHead?.isExecutiveRecipient
		};
	}

	// CC: taken from inbound-mailboxes.component.ts -> updateMailboxJobTitle
	updateMailboxRole = () => {
		if (this.mailboxRolePopup.inProcess || !this.mailboxRolePopup.name) {
			return;
		}

		const updateData:any = {
			action: this.dic.CONSTANTS.inboundMailboxAction.jobTitle.value,
			email: this.mailboxRolePopup.email,
			job_title: this.mailboxRolePopup.name.trim(),
			is_executive: this.mailboxRolePopup.is_executive
		};

		this.mailboxRolePopup.inProcess = true;

		this.rs.updateMailboxInfo(updateData).then(() => {
			if (this.curTPResults?.resHead) {
				this.curTPResults.resHead.recipientJobTitle = updateData.job_title;
				this.curTPResults.resHead.isExecutiveRecipient = updateData.is_executive;
			}

			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
			this.mailboxRolePopup.show = false;
			this.mailboxRolePopup.inProcess = false;
		}, (err) => {
			if (!err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.mailboxRolePopup.inProcess = false;
		});
	}

	openSetCategoryPopup = (email) => {
		this.setCategoryPopup = {
			email: email,
			newCategory: email.category,
			reportToTrustifi: email?.status === this.dic.CONSTANTS.quarantinedActions.release.value,
			blocklistSenderIdentity: false,
			reason: '',
			show: true
		};
	}

	openSetMultipleCategoryPopup = (selectedEmails) => {
		this.setCategoryPopup = {
			newCategory: selectedEmails[0].category,
			selectedEmails,
			multiple: true,
			reportToTrustifi: selectedEmails.every(emailObj => emailObj?.status === this.dic.CONSTANTS.quarantinedActions.release.value),
			blocklistSenderIdentity: false,
			reason: '',
			show: true
		};
	}

	setCategoryConfirm = () => {
		if (this.setCategoryPopup.email && this.setCategoryPopup.email.category === this.setCategoryPopup.newCategory && !this.setCategoryPopup.reason) {
			this.ns.showWarnMessage(this.dic.ERRORS.noChanges);
			return;
		}
		if (this.setCategoryPopup.multiple && !_.filter(_.map(this.setCategoryPopup.selectedEmails, 'category'), c => c !== this.setCategoryPopup.newCategory).length && !this.setCategoryPopup.reason) {
			this.ns.showWarnMessage(this.dic.ERRORS.noChanges);
			return;
		}

		if (['Safe', 'External'].includes(this.setCategoryPopup.newCategory)) {
			this.setCategoryPopup.blocklistSenderIdentity = false;
		}

		const categoryInfo = {
			category: this.setCategoryPopup.newCategory,
			reason: this.setCategoryPopup.reason,
			reportToTrustifi: this.setCategoryPopup.reportToTrustifi,
			blocklistSenderIdentity: this.setCategoryPopup.blocklistSenderIdentity
		};

		if (!this.planInfo?.allowGlobalAllowBlockLists && categoryInfo.blocklistSenderIdentity) {
			delete categoryInfo.blocklistSenderIdentity;
			const items = [{value: this.setCategoryPopup.email?.sender, description: categoryInfo.reason}];
			const userConfigData = {type: this.dic.CONSTANTS.quarantinedActions.blacklist.value, action: 'Add', items, userEmail: getCurrentMailbox(this.setCategoryPopup.email)};
			this.rs.updateTpConfigUsers(userConfigData).then((response) => {
			}, err => {
			});
		}

		const showResultMessages = () => {
			if (categoryInfo.reportToTrustifi) {
				this.ns.showInfoMessage(this.dic.MESSAGES.quarantineReport);
				this.popupError = {error: {type: 'info', message: this.dic.MESSAGES.quarantineReport}};
			}
			else {
				if (categoryInfo.blocklistSenderIdentity) {
					this.ns.showInfoMessage(this.dic.MESSAGES.quarantinedSetCategoryBlocklist);
					this.popupError = {error: {type: 'info', message: this.dic.MESSAGES.quarantinedSetCategoryBlocklist}};
				}
				else {
					this.ns.showInfoMessage(this.dic.MESSAGES.quarantinedSetCategory);
					this.popupError = {error: {type: 'info', message: this.dic.MESSAGES.quarantinedSetCategory}};
				}
			}
		};

		if (this.setCategoryPopup.multiple) {
			const selectedEmails = this.setCategoryPopup.selectedEmails;
			this.setCategoryPopup = null;
			this.setCategoryMultipleQuarantinedEmail(selectedEmails, 0, categoryInfo, () => {
				showResultMessages();
				this.actionFinished();
			});
		}
		else {
			this.setCategoryPopup.setCategoryInProcess = true;
			this.setCategoryExecute(this.setCategoryPopup.email, categoryInfo, () => {
				showResultMessages();
				this.setCategoryPopup = null;
				this.actionFinished();
			});
		}
	}

	setCategoryMultipleQuarantinedEmail = (emails, idx, categoryInfo, cb) => {
		eachLimit(emails, 10, (emailObj, asyncCb) => {
			this.setCategoryExecute(emailObj, categoryInfo, () => {
				asyncCb();
			});
		}, () => {
			cb();
		});
	}

	setCategoryExecute = (email, categoryInfo, cb) => {
		if (email.parent) {
			this.setCategoryMultipleQuarantinedEmail(email.emails.filter(childEmail => !childEmail.hide), 0, categoryInfo, () => {
				email.category = categoryInfo.category;
				email.reason = categoryInfo.reason;
				email.malicious.status_user_reported = email.category;
				this.setEmailCategory(email);
				if (this.emailInfoPopup) {
					this.emailInfoPopup.category = email.category;
				}
				cb();
				if (categoryInfo.reportToTrustifi) {
					email.report = {report_by: 'reviewer'};
				}
			});
			return;
		}

		const data = {
			action: this.dic.CONSTANTS.quarantinedActions.setCategory.value,
			category: categoryInfo.category,
			reason: categoryInfo.reason,
			reportToTrustifi: categoryInfo.reportToTrustifi,
			blocklistSenderIdentity: categoryInfo.blocklistSenderIdentity
		};
		const emailId = getEmailId(email);
		this.doActionOnQuarantinedEmailRetry(emailId, data, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
			email.category = categoryInfo.category;
			email.reason = categoryInfo.reason;
			email.malicious.status_user_reported = email.category;
			this.setEmailCategory(email);
			if (this.emailInfoPopup) {
				this.emailInfoPopup.category = email.category;
			}
			this.addReviewerAction(email, response.reviewerActivity);
			cb();
			if (data.reportToTrustifi) {
				email.report = {report_by: 'reviewer'};
			}
		}, (err) => {
			this.popupError = this.ns.getCurrentMessage();
			if (this.setCategoryPopup) {
				this.setCategoryPopup.setCategoryInProcess = false;
			}
		});
	}

	allowBlockedFileType = (email) => {
		this.gs.showPopup({
			title: 'Allow File Type',
			subTitle: "You are about to set this uncommon file type as allowed.",
			body: ['Emails with this type of file will no longer be blocked'],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Allow',
			doneCb: () => {
				this.allowBlockedFileTypeExecute(email, () => {});
			}
		});
	}

	allowBlockedFileTypeExecute = (email, cb) => {
		const data = {action: this.dic.CONSTANTS.quarantinedActions.allowFileType.value};
		const emailId = getEmailId(email);
		this.rs.doActionOnQuarantinedEmail(emailId, data, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
			this.ns.showInfoMessage(this.dic.MESSAGES.changedSuccessfully);
			_.remove<any>(this.curEmail.methods, method => {
				return method === this.dic.CONSTANTS.quarantinedActions.allowFileType.value;
			});
			this.popupError = this.ns.getCurrentMessage();
			this.addReviewerAction(email, response.reviewerActivity);
			cb();
		}, err => {
			this.popupError = this.ns.getCurrentMessage();
			cb();
		});
	}

	signaturePopup = (email) => {
		const body = [`The source will be signed and considered safe and valid for this domain`];
		if (this.curTPResults.resHead.spf.score <= 1 || this.curTPResults.resHead.dmarc.score <= 1) {
			body.push('Note: SPF/DMARC has failed for this source. It is not recommended to sign sources with failed SPF/DMARC as it may indicate the email was spoofed.');
		}

		this.gs.showPopup({
			title: 'Sign Quarantined Email Source',
			subTitle: "Please note - you are about to sign source for this email",
			body: body,
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Sign Source',
			doneCb: () => {
				this.signatureExecute(email, () => {});
			}
		});
	}

	signatureExecute = (email, cb) => {
		const data = {action: this.dic.CONSTANTS.quarantinedActions.signature.value};
		const emailId = getEmailId(email);
		this.rs.doActionOnQuarantinedEmail(emailId, data, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
			_.remove(email.methods, m => m === this.dic.CONSTANTS.quarantinedActions.signature.value);
			email.methods.push(this.dic.CONSTANTS.quarantinedActions.removeSource.value);
			this.ns.showInfoMessage(this.dic.MESSAGES.quarantinedSignSource);
			this.popupError = this.ns.getCurrentMessage();
			this.addReviewerAction(email, response.reviewerActivity);
			cb();
		}, err => {
			this.popupError = this.ns.getCurrentMessage();
			cb();
		});
	}

	removeSourcePopup = (email) => {
		this.gs.showPopup({
			title: 'Remove Quarantined Email Source',
			subTitle: "Please note - you are about to remove source for this email",
			body: [`The source will be removed from the trusted sources for this domain`],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Remove Source',
			doneCb: () => {
				this.removeSourceExecute(email, () => {});
			}
		});
	}

	removeSourceExecute = (email, cb) => {
		const data = {action: this.dic.CONSTANTS.quarantinedActions.removeSource.value};
		const emailId = getEmailId(email);
		this.rs.doActionOnQuarantinedEmail(emailId, data, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
			_.remove(email.methods, m => m === this.dic.CONSTANTS.quarantinedActions.removeSource.value);
			email.methods.push(this.dic.CONSTANTS.quarantinedActions.signature.value);
			this.ns.showInfoMessage('Source removed successfully');
			this.popupError = this.ns.getCurrentMessage();
			this.addReviewerAction(email, response.reviewerActivity);
			cb();
		}, err => {
			this.popupError = this.ns.getCurrentMessage();
			cb();
		});
	}

	showReleaseQuarantinedEmailPopup = (emails) => {
		if (!emails.length) {
			return;
		}

		this.addWarningLabel = false;
		this.addSubjectText = false;
		this.deleteRecord = false;
		this.addContactToAdmin = false;
		this.reportToTrustifi = emails.every(emailObj => emailObj?.status === this.dic.CONSTANTS.quarantinedActions.quarantine.value);
		this.blocklistSenderIdentity = false;
		this.removeFromBlocklist = false;
		this.setCategoryAsSafe = false;
		this.releaseAddSenderToAllowlist = false;
		this.releaseDefangUrl = false;

		let subTitle;
		if (emails.length > 1) {
			subTitle = `Please note - you are about to release ${emails.length} emails back to the recipient's inbox`;
		}
		else {
			const visibleChildrenCount = emails[0].parent ? emails[0].emails.filter(childEmail => !childEmail.hide).length : 0;
			subTitle = `Please note - you are about to release this email back to ${visibleChildrenCount > 1 ? `${visibleChildrenCount} recipient inboxes` : 'the recipient\'s inbox'}`;
		}

		if (emails[0].source === this.emailsSources.exchange) {
			this.gs.showPopup({
				title: 'Microsoft Exchange Quarantine Release',
				subTitle: subTitle,
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Release',
				doneCb: () => {
					this.ns.showInfoMessage('The selected email is being released, the email status will be updated');
					emails.forEach((emailObj) => {
						const data = {
							action: this.dic.CONSTANTS.quarantinedActions.release.value,
							id: getEmailId(emailObj),
							subject: emailObj.subject,
							mailbox_email: getCurrentMailbox(emailObj),
							message_id: emailObj.message_id
						};
						this.rs.exchangeDoActionOnQuarantinedEmail(data).then((response) => {
							emailObj.status = this.dic.CONSTANTS.quarantinedActions.release.value;
						});
					});
				}
			});
			return;
		}

		const trustSenderObj = {
			labelName: 'Trust sender',
			tooltip: 'The sender will be trusted for all users in the plan. Emails from trusted senders are less likely to be considered spam or as threats.',
			model: this.addContactToAdmin
		};
		const resHead = emails[0]?.malicious?.tpResults?.resHead;
		const subStatus = resHead?.sub_status;
		const headCategory = resHead?.category;
		const headStatus = emails[0]?.malicious?.status;

		const sourceMismatchSubStatuses = ['Source Mismatch', 'Global Source Mismatch'];
		const recommendedSubStatuses = ['Sender Allowlist Signature Mismatch', 'Contact Impersonation', 'Mailbox Impersonation', 'Executive Impersonation', 'Potential Service Abuse', 'Service Abuse', 'Unreleased Quarantine Chain', 'Trusted Contact Anomaly', 'Recipient Header Anomaly', 'Unique Recipients', 'Unsolicited Recipients'];
		const recommendedHeadCategories = ['Impersonation', 'User Preferences', 'Third Party Verdict'];
		const recommendedHeadStatuses = ['Suspicious', 'Spam', 'Graymail'];

		const isSourceMismatchSubStatus = typeof subStatus === 'string' && sourceMismatchSubStatuses.includes(subStatus);
		const isRecommendedSubStatus = typeof subStatus === 'string' && recommendedSubStatuses.includes(subStatus);
		const isRecommendedHeadCategory = typeof headCategory === 'string' && recommendedHeadCategories.includes(headCategory);
		const isRecommendedHeadStatus = typeof headStatus === 'string' && recommendedHeadStatuses.includes(headStatus);
		const shouldAutoTrustSender = isSourceMismatchSubStatus || isRecommendedSubStatus || isRecommendedHeadCategory || isRecommendedHeadStatus;

		if (isSourceMismatchSubStatus) {
			trustSenderObj.labelName += ' (recommended)';
			trustSenderObj.tooltip = `Select this option if this source is allowed for sending emails for domain ${this.gs.getDomain(emails[0].sender)} to ensure the system does not block future similar emails`;
		}
		else if (isRecommendedSubStatus || isRecommendedHeadCategory || isRecommendedHeadStatus) {
			trustSenderObj.labelName += ' (recommended)';
			trustSenderObj.tooltip = 'Select this option if you trust this sender/email to ensure the system does not block future similar emails';
		}

		if (shouldAutoTrustSender) {
			this.addContactToAdmin = true;
			trustSenderObj.model = this.addContactToAdmin;
		}

		// Do not send reports to Trustifi by default on Safe/External
		if (emails.every(emailObj => ['Safe', 'External'].includes(emailObj.malicious.status))) {
			this.reportToTrustifi = false;
			this.blocklistSenderIdentity = false;
		}

		// Do not send reports to Trustifi by default on Blocklist, User Preferences, Spoofing
		if (emails.every(emailObj => ['Blocklist', 'User Preferences', 'Spoofing'].includes(emailObj.malicious.tpResults.resHead.category))) {
			if (!emails.some(emailObj => typeof emailObj.malicious.tpResults.resHead.sub_status === 'string' && emailObj.malicious.tpResults.resHead.sub_status.endsWith('Threat Intelligence'))) {
				this.reportToTrustifi = false;
			}
		}

		const releaseOptions = [
			{
				labelName: 'Add warning label',
				tooltip: 'The relevant warning label will be added to the email when it is released.',
				model: this.addWarningLabel
			},
			{
				labelName: 'Add subject text',
				tooltip: 'The relevant text will be added to the email subject when it is released.',
				model: this.addSubjectText
			},
			trustSenderObj,
			{
				labelName: 'Report to Trustifi (recommended)',
				tooltip: 'Our dedicated security team review each report daily and takes necessary actions to adjust our security features accordingly.\n' +
					'Based on feedback, our team can adjust the AI, add malicious senders to the global blocklist, enhance our security metrics and more.',
				model: this.reportToTrustifi
			},
			{
				labelName: 'Set category as safe',
				tooltip: 'Quarantine cateogry will be set as Safe',
				model: this.setCategoryAsSafe
			},
			{
				labelName: this.planInfo?.allowGlobalAllowBlockLists ? 'Add sender to global allowlist' : 'Add sender to personal allowlist',
				tooltip: 'Allowlisted emails will be automatically released to the recipient\'s inbox',
				model: this.releaseAddSenderToAllowlist,
				showInput: true,
				inputModel: '',
			}
		];

		if (emails[0].malicious.tpResults.resHead?.category === 'Blocklist') {
			this.removeFromBlocklist = true;
			releaseOptions.push({
				labelName: 'Remove sender from blocklist',
				tooltip: 'Sender will be removed from blocklist',
				model: this.removeFromBlocklist
			});
		}
		if (emails[0].malicious.tpResults.resUrl?.status === 'Malicious') {
			releaseOptions.push({
				labelName: 'Defang Malicious URLs',
				tooltip: 'All malicious URLs in the released email will be defanged and not clickable',
				model: this.releaseDefangUrl
			});
		}

		if (this.isDeleteActionAllowed()) {
			releaseOptions.push({
				labelName: 'Delete record',
				tooltip: 'After the email is released, the quarantined email record will be deleted.',
				model: this.deleteRecord
			});
		}

		this.releaseQuarantinedEmailPopup = {
			show: true,
			applyInProcess: false,
			subTitle: subTitle,
			releaseOptionsToggles: releaseOptions,
			doneCb: () => {
				this.releaseQuarantinedEmailPopup.applyInProcess = true;
				let releaseOptions:any = {};
				releaseOptions.blocklistSenderIdentity = false;
				const toggles = this.releaseQuarantinedEmailPopup.releaseOptionsToggles;
				const releaseToggle = (base: string) => toggles.find(itm => itm.labelName === base || itm.labelName === `${base} (recommended)`);
				if (releaseToggle('Add warning label')?.model) {
					releaseOptions.addWarningLabel = true;
				}
				if (releaseToggle('Add subject text')?.model) {
					releaseOptions.addSubjectText = true;
				}
				if (releaseToggle('Trust sender')?.model) {
					releaseOptions.addContactToAdmin = true;
				}
				if (releaseToggle('Report to Trustifi')?.model) {
					releaseOptions.reportToTrustifi = true;
				}
				if (releaseToggle('Delete record')?.model) {
					releaseOptions.deleteRecord = true;
				}
				if (releaseToggle('Remove sender from blocklist')?.model) {
					const data = {
						type: 'blacklist',
						action: DICTIONARY.CONSTANTS.inboundConfigurationsActions.remove,
						items: [{value: emails[0].sender}],
						userEmail: emails[0].mailbox_email.toString()
					};
					this.rs.updateTpConfig(data);
					this.rs.updateTpConfigUsers(data);
				}
				if (releaseToggle('Set category as safe')?.model) {
					releaseOptions.setCategory = 'Safe';
				}
				if (releaseToggle('Defang Malicious URLs')?.model) {
					releaseOptions.defangUrls = true;
				}
				const senderGlobalAllowlist = releaseToggle('Add sender to global allowlist');
				if (senderGlobalAllowlist?.model) {
					releaseOptions.addSenderToAllowlist = true;
					releaseOptions.allowlistDescription = senderGlobalAllowlist.inputModel;
				}

				const senderPersonalAllowlist = releaseToggle('Add sender to personal allowlist');
				if (senderPersonalAllowlist?.model) {
					const items = [{value: emails[0].sender, description: senderPersonalAllowlist.inputModel}];
					const userConfigData = {type: this.dic.CONSTANTS.quarantinedActions.whitelist.value, action: 'Add', items, userEmail: getCurrentMailbox(emails[0])};
					this.rs.updateTpConfigUsers(userConfigData).then((response) => {
					}, err => {
					});
				}

				this.releaseQuarantinedEmailPopup.applyInProcess = false;
				this.releaseQuarantinedEmailPopup.show = false;

				this.releaseMultipleQuarantinedEmail(emails, 0, releaseOptions, () => {
					if (emails.length > 1) {
						this.ns.showInfoMessage(`Operation completed successfully for ${emails.length} emails`);
					}

					if (this.curEmail?.methods) {
						_.remove<any>(this.curEmail.methods, method => {
							return method === this.dic.CONSTANTS.quarantinedActions.release.value;
						});
						if (this.curEmail.status === this.dic.CONSTANTS.quarantinedActions.release.value) {
							this.curEmail.methods.push(this.dic.CONSTANTS.quarantinedActions.remove.value);
						}
						if (releaseOptions.deleteRecord) {
							this.curEmail.methods = [];
							this.curEmail.senderMethods = [];
						}
					}

					this.popupError = this.ns.getCurrentMessage();
					this.actionFinished();
				});
			}
		};
	}

	releaseQuarantinedEmailExecute = (email, releaseOptions, cb) => {
		if (email.parent) {
			this.releaseMultipleQuarantinedEmail(email.emails.filter(childEmail => !childEmail.hide), 0, releaseOptions, () => {
				email.status = getFirstVisibleChild(email).status;
				if (releaseOptions.setCategory) {
					email.malicious.status_user_reported = releaseOptions.setCategory;
					this.setEmailCategory(email);
				}
				if (releaseOptions.deleteRecord) {
					this.onActionDone.emit({action: 'releaseDeleteRecord', email});
				}
				cb();
			});
			return;
		}

		if (email.status === this.dic.CONSTANTS.quarantinedActions.pending.value) {
			return cb();
		}

		const data = {
			action: this.dic.CONSTANTS.quarantinedActions.release.value,
			skipWarningLabel: !releaseOptions.addWarningLabel,
			addSubjectText: releaseOptions.addSubjectText,
			addContactToAdmin: releaseOptions.addContactToAdmin,
			addSenderToAllowlist: releaseOptions.addSenderToAllowlist,
			allowlistDescription: releaseOptions.allowlistDescription,
			defangUrls: releaseOptions.defangUrls,
			reportToTrustifi: releaseOptions.reportToTrustifi,
			setCategory: releaseOptions.setCategory,
			deleteRecord: releaseOptions.deleteRecord
		};
		const emailId = getEmailId(email);
		this.rs.doActionOnQuarantinedEmail(emailId, data, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
			email.status = response.status;
			email.reason = response.reason || this.reviewerInfo.email;
			if (releaseOptions.setCategory) {
				email.malicious.status_user_reported = releaseOptions.setCategory;
				this.setEmailCategory(email);
			}

			if (data.reportToTrustifi) {
				email.report = {report_by: 'reviewer'};
			}

			this.addReviewerAction(email, `Released email to ${email.mailbox_email}`);

			if (email.status === this.dic.CONSTANTS.quarantinedActions.pending.value) {
				this.onActionDone.emit({action: this.dic.CONSTANTS.quarantinedActions.release.value, email});
			}

			cb();
		}, err => {
			this.popupError = this.ns.getCurrentMessage();
			cb();
		});
	}

	releaseMultipleQuarantinedEmail = (emails, idx, releaseOptions, cb) => {
		eachLimit(emails, 10, (emailObj, asyncCb) => {
			this.releaseQuarantinedEmailExecute(emailObj, releaseOptions, () => {
				asyncCb();
			});
		}, () => {
			cb();
		});
	}

	removeQuarantinedEmailPopup = (emails) => {
		this.blocklistSenderIdentity = true;
		if (!emails.length) {
			return;
		}
		this.reportToTrustifi = emails.every(emailObj => emailObj?.status === this.dic.CONSTANTS.quarantinedActions.release.value);
		let title, subTitle, body;
		if (emails.length > 1) {
			title = 'Remove Quarantined Emails';
			subTitle = `Please note - you are about to remove ${emails.length} emails from quarantine`;
			body = ['Emails will be removed'];
		}
		else {
			title = 'Remove Quarantined Email';
			const visibleChildrenCount = emails[0].parent ? emails[0].emails.filter(childEmail => !childEmail.hide).length : 0;
			subTitle = `Please note - you are about to remove this email from ${visibleChildrenCount > 1 ? `${visibleChildrenCount} recipient mailboxes` : 'the recipient\'s inbox'}`;
			body = [`Email ${emails[0].subject} will be removed`];
		}
		this.removeQuarantinedPopup = {
			show: true,
			applyInProcess: false,
			title: title,
			subTitle: subTitle,
			removeOptionsToggles: [
				{
					labelName: 'Report to Trustifi (recommended)',
					tooltip: 'Our dedicated security team review each report daily and takes necessary actions to adjust our security features accordingly.\n' +
						'Based on feedback, our team can adjust the AI, add malicious senders to the global blocklist, enhance our security metrics and more.',
					model: this.reportToTrustifi
				},
				{
					labelName: 'Blocklist Sender Identity',
					tooltip: 'The sender\'s identity will be added to the blocklist, ensuring no further messages are received.',
					model: this.blocklistSenderIdentity,
					showInput: true,
					inputModel: ''
				}
			],
			body: body,
			doneCb: () => {
				this.removeQuarantinedPopup.applyInProcess = true;
				let releaseOptions:any = {};
				if (this.removeQuarantinedPopup.removeOptionsToggles && this.removeQuarantinedPopup.removeOptionsToggles[0] && this.removeQuarantinedPopup.removeOptionsToggles[0].model) {
					releaseOptions.reportToTrustifi = this.removeQuarantinedPopup.removeOptionsToggles[0].model;
				}
				if (this.removeQuarantinedPopup.removeOptionsToggles && this.removeQuarantinedPopup.removeOptionsToggles[1] && this.removeQuarantinedPopup.removeOptionsToggles[1].model) {
					if (this.planInfo?.allowGlobalAllowBlockLists) {
						releaseOptions.blocklistSenderIdentity = this.removeQuarantinedPopup.removeOptionsToggles[1].model;
						releaseOptions.blocklistDescription = this.removeQuarantinedPopup.removeOptionsToggles[1].inputModel;
					}
					else {
						const items = [{value: emails[0].sender}];
						const userConfigData = {type: this.dic.CONSTANTS.quarantinedActions.blacklist.value, action: 'Add', items, userEmail: getCurrentMailbox(emails[0])};
						this.rs.updateTpConfigUsers(userConfigData).then((response) => {
						}, err => {
						});
					}
				}
				this.removeQuarantinedPopup.applyInProcess = false;
				this.removeQuarantinedPopup.show = false;
				this.removeMultipleQuarantinedEmail(emails, 0, releaseOptions, () => {
					if (emails.length > 1) {
						this.ns.showInfoMessage(`${emails.length} quarantined email records were removed successfully`);
					}

					if (this.curEmail?.methods) {
						_.remove<any>(this.curEmail.methods, m => m === this.dic.CONSTANTS.quarantinedActions.remove.value);
						this.curEmail.methods.push(this.dic.CONSTANTS.quarantinedActions.release.value);
					}

					this.popupError = this.ns.getCurrentMessage();
					this.actionFinished();
				});
			}
		};
	}

	removeQuarantinedEmailExecute = (email, releaseOptions, cb) => {
		if (email.parent) {
			this.removeMultipleQuarantinedEmail(email.emails.filter(childEmail => !childEmail.hide), 0, releaseOptions, () => {
				// update parent email only if operation succeeded
				const removedChild = getFirstVisibleChild(email);
				if (removedChild.status === this.dic.CONSTANTS.quarantinedActions.remove.value) {
					email.status = this.dic.CONSTANTS.quarantinedActions.remove.value;
					email.reason = removedChild.reason;
					this.addReviewerAction(email, null);
				}
				cb();
			});
			return;
		}

		if (email.status === this.dic.CONSTANTS.quarantinedActions.pending.value) {
			this.ns.showErrorMessage('Cannot remove email while the status is "Pending release"');
			return cb();
		}
		if (email.status !== this.dic.CONSTANTS.quarantinedActions.release.value) {
			return cb();
		}

		if (email.source === this.emailsSources.exchange) {
			const data = {
				action: this.dic.CONSTANTS.quarantinedActions.remove.value,
				id: getEmailId(email),
				mailbox_email: getCurrentMailbox(email),
				message_id: email.message_id
			};
			this.rs.exchangeDoActionOnQuarantinedEmail(data).then(() => {
				email.status = this.dic.CONSTANTS.quarantinedActions.remove.value;
				this.addReviewerAction(email, `Removed email from ${email.mailbox_email}`);
				this.ns.showInfoMessage(`Removed email from ${email.mailbox_email}`);
				cb();
			}, err => {
				this.popupError = this.ns.getCurrentMessage();
				cb();
			});
			return;
		}

		const data = {
			action: this.dic.CONSTANTS.quarantinedActions.remove.value,
			reportToTrustifi: releaseOptions.reportToTrustifi,
			blocklistSenderIdentity: releaseOptions.blocklistSenderIdentity,
			blocklistDescription: releaseOptions.blocklistDescription
		};
		const emailId = getEmailId(email);
		this.rs.doActionOnQuarantinedEmail(emailId, data, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
			email.status = response.status;
			email.reason = response.reason || '';
			this.addReviewerAction(email, response.reviewerActivity);
			cb();
		}, err => {
			this.popupError = this.ns.getCurrentMessage();
			cb();
		});
	}

	removeMultipleQuarantinedEmail = (emails, idx, releaseOptions, cb) => {
		eachLimit(emails, 10, (emailObj, asyncCb) => {
			this.removeQuarantinedEmailExecute(emailObj, releaseOptions, () => {
				asyncCb();
			});
		}, () => {
			cb();
		});
	}

	deleteQuarantinedEmailPopup = (emails) => {
		if (!emails.length) {
			return;
		}

		const body = ['You will no longer be able to apply actions to these emails'];
		this.gs.showPopup({
			title: 'Delete Quarantined Email Records',
			subTitle: `Please note - you are about to delete ${emails.length} quarantined email's records`,
			body: body,
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Delete',
			doneCb: () => {
				this.deleteMultipleQuarantinedEmails(emails, () => {
					const deletedEmails = _.flatMap(emails, (emailObj) => {
						return emailObj?.parent ? emailObj.emails.filter((childEmail) => !childEmail.hide) : [emailObj];
					});
					this.onActionDone.emit({action: this.dic.CONSTANTS.quarantinedActions.delete.value, emails: deletedEmails});

					if (emails.length > 1) {
						this.ns.showInfoMessage(`${emails.length} Quarantined email records were deleted successfully`);
					}
					else {
						this.ns.showInfoMessage(`Quarantined email record was deleted successfully`);
					}

					this.popupError = this.ns.getCurrentMessage();
				});
			}
		});
	}

	deleteQuarantinedEmailExecute = (email, cb) => {
		if (email.parent) {
			this.deleteMultipleQuarantinedEmails(email.emails.filter(childEmail => !childEmail.hide), () => {
				cb();
			});
			return;
		}

		if (email.status === this.dic.CONSTANTS.quarantinedActions.pending.value) {
			return cb();
		}

		const emailId = getEmailId(email);
		if (email.source === this.emailsSources.exchange) {
			const data = {
				action: 'Delete',
				id: emailId,
				mailbox_email: getCurrentMailbox(email),
				message_id: email.message_id
			};
			this.rs.exchangeDoActionOnQuarantinedEmail(data).then(() => {
				cb();
			});
		}
		else {
			this.rs.deleteQuarantinedEmail(emailId, this.getPlanIdParams(email)).then(() => {
				cb();
			});
		}
	}

	deleteMultipleQuarantinedEmails = (emails, cb) => {
		eachLimit(emails, 10, (emailObj, asyncCb) => {
			this.deleteQuarantinedEmailExecute(emailObj, asyncCb);
		}, () => {
			cb();
		});
	}

	requestReleaseQuarantinedEmailPopup = (email) => {
		if (email.status === this.dic.CONSTANTS.quarantinedActions.pending.value
			|| email.status === this.dic.CONSTANTS.quarantinedActions.release.value) {
			return;
		}

		this.requestReleasePopup = {
			show: true,
			reason: '',
			applyInProcess: false,
			doneCb: () => {
				const data: any = {
					action: this.dic.CONSTANTS.quarantinedActions.requestRelease.value,
				};
				if (this.requestReleasePopup.reason) {
					data.reason = this.requestReleasePopup.reason;
				}
				const emailId = getEmailId(email);
				this.requestReleasePopup.applyInProcess = true;
				this.rs.doActionOnQuarantinedEmail(emailId, data, this.getPlanIdParamsForQuarantineAction(this.curEmail)).then((response) => {
					email.status = this.dic.CONSTANTS.quarantinedActions.requestRelease.value;
					this.ns.showInfoMessage("Release request has been sent");
					this.requestReleasePopup.applyInProcess = false;
					this.actionFinished();
				}, err => {
					this.requestReleasePopup.applyInProcess = false;
				});
			}
		};
	}

	requestedReleaseRejectPopup = (email) => {
		this.releaseRejectPopup = {
			show: true,
			securityTeamComments: '',
			applyInProcess: false,
			doneCb: () => {
				this.releaseRejectPopup.applyInProcess = true;
				const data = {
					action: this.dic.CONSTANTS.quarantinedActions.requestedReleaseReject.value,
					reason: this.releaseRejectPopup.securityTeamComments
				};
				const emailId = getEmailId(email);
				this.rs.doActionOnQuarantinedEmail(emailId, data, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
					email.status = this.dic.CONSTANTS.quarantinedActions.quarantine.value;
					email.reason = 'Release request rejected';
					_.remove<any>(this.curEmail.methods, method => {
						return method === this.dic.CONSTANTS.quarantinedActions.requestedReleaseReject.value;
					});
					this.addReviewerAction(email, response.reviewerActivity);

					this.ns.showInfoMessage(`Operation completed successfully`);
					this.releaseRejectPopup.applyInProcess = false;
					this.releaseRejectPopup.show = false;
					this.actionFinished();
				}, err => {
					this.releaseRejectPopup.applyInProcess = false;
					this.popupError = this.ns.getCurrentMessage();
				});
			}
		};
	}

	initSenderObjItems = () => {
		this.actionForHeaders = {
			senderEmail: false,
			senderEmailAppearsAs: false,
			senderDomain: false,
			replyToEmail: false,
			replyToDomain: false,
			returnPath: false,
			returnPathEmail: false,
			sendingMTA: false,
			sendingMTADomain: false,
			messageID: false,
		};
	}

	addSenderWhiteListPopup = (email) => {
		if (!email) {
			return;
		}

		this.initSenderObjItems();

		const domainWarning = "Do not add domains you own or popular domains (e.g. gmail.com) to the domain allowlist. This creates opportunities for attackers to send you email that would otherwise be blocked";

		const items: any = [
			{text: `Sender email: ${email.sender}`, model: this.actionForHeaders.senderEmail, value: email.sender, type: 'email', sender: true},
			{text: `Sender domain: ${this.gs.getDomain(email.sender)}`, model: this.actionForHeaders.senderDomain, value: this.gs.getDomain(email.sender), type: 'domain', warning: domainWarning},
			{text: `Reply-to email: ${email.malicious.tpResults.resHead.from.replyTo}`, model: this.actionForHeaders.replyToEmail, value: email.malicious.tpResults.resHead.from.replyTo, type: 'email'},
			{text: `Reply-to domain: ${this.gs.getDomain(email.malicious.tpResults.resHead.from.replyTo)}`, model: this.actionForHeaders.replyToDomain, value: this.gs.getDomain(email.malicious.tpResults.resHead.from.replyTo), type: 'domain', warning: domainWarning},
		];

		if (email.malicious.tpResults.resHead.from?.ipAddresses?.length) {
			email.malicious.tpResults.resHead.from.ipAddresses.forEach((ipAddr) => {
				this.actionForHeaders[ipAddr] = false;
				items.push({text: `Sender IP address: ${ipAddr}`, model: this.actionForHeaders[ipAddr], value: ipAddr, type: 'ip'});
			});
		}

		this.allowlistSenderPopup = {
			show: true,
			items: items,
			email: email,
			actionScope: this.planInfo?.allowGlobalAllowBlockLists ? 'global' : 'mailbox',
		};
	}

	addSenderWhiteListPopupExecute = () => {
		this.actionInProcess = true;

		const items = this.allowlistSenderPopup.items.filter(itm => itm.model);
		items.forEach((itemObj) => {
			itemObj.description = this.allowlistSenderPopup.reason || '';
		});
		if (!items.length) {
			this.ns.showErrorMessage('You must select at least one header');
			this.actionInProcess = false;
			return;
		}

		const mailboxEmail = this.allowlistSenderPopup.actionScope === 'mailbox' ? getCurrentMailbox(this.allowlistSenderPopup.email) : '';

		this.addSenderWhiteListExecute(this.allowlistSenderPopup.email, items, mailboxEmail, () => {
			this.actionInProcess = false;
			this.allowlistSenderPopup.show = false;
			this.actionFinished();

			const currentMsg = this.ns.getCurrentMessage();
			if (currentMsg && currentMsg.error) {
				this.popupError = currentMsg;
			}
			else {
				if (this.curEmail && this.curEmail.senderMethods) {
					_.remove<any>(this.curEmail.senderMethods, m => m === this.dic.CONSTANTS.quarantinedActions.whitelist.value);
					this.curEmail.senderMethods.push(this.dic.CONSTANTS.quarantinedActions.blacklist.value);
				}
				this.popupError = null;
				this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, 'sender'));
			}
		});
	}

	addSenderWhiteListExecute = (email, items, mailboxEmail, cb) => {
		if (mailboxEmail) {
			const userConfigData = {type: this.dic.CONSTANTS.quarantinedActions.whitelist.value, action: 'Add', items, userEmail: mailboxEmail};
			this.rs.updateTpConfigUsers(userConfigData).then((response) => {
				this.addReviewerAction(email, response && response.reviewerActivity);
				cb();
			}, err => {
				this.popupError = this.ns.getCurrentMessage();
				cb(err);
			});
		}
		else {
			const planConfigData = {action: this.dic.CONSTANTS.quarantinedActions.whitelist.value, items: items};
			const emailId = getEmailId(email);
			this.rs.doActionOnQuarantinedEmail(emailId, planConfigData, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
				this.addReviewerAction(email, response.reviewerActivity);
				cb();
			}, err => {
				this.popupError = this.ns.getCurrentMessage();
				cb(err);
			});
		}
	}

	addMultipleSenderBlackListPopup = (emails) => {
		if (!emails?.length) {
			return;
		}

		this.initSenderObjItems();

		this.blocklistSenderPopup = {
			show: true,
			items: [{model: true, type: 'email', sender: true}],
			emails,
			actionScope: this.planInfo?.allowGlobalAllowBlockLists ? 'global' : 'mailbox'
		};
	}

	addBulkSenderBlacklistPopupExecute = (currentSenderIdx = 0, blockedSuccessfully = []) => {
		if (!this.blocklistSenderPopup.emails[currentSenderIdx]) {
			if (blockedSuccessfully.length) {
				blockedSuccessfully = [...new Set(blockedSuccessfully)];
				this.ns.showInfoMessage(blockedSuccessfully.length + ` sender${blockedSuccessfully.length > 1 ? 's' : ''} blocked successfully: ` + blockedSuccessfully.join(', '));
			}
			return;
		}

		let email = this.blocklistSenderPopup.emails[currentSenderIdx];
		this.blocklistSenderPopup.email = email;
		this.blocklistSenderPopup.items[0].value = email.malicious.tpResults.resHead.from.senderMailFrom;

		this.addSenderBlacklistPopupExecute((err) => {
			if (!err) {
				blockedSuccessfully.push(email.malicious.tpResults.resHead.from.senderMailFrom);
			}

			currentSenderIdx++;
			this.addBulkSenderBlacklistPopupExecute(currentSenderIdx, blockedSuccessfully);
		});
	}

	addSenderBlackListPopup = (email) => {
		if (!email) {
			return;
		}

		this.initSenderObjItems();

		const domainWarning = "It is recommended not to add free email domains or other popular domains to your blocklist, as this may cause safe emails from these domains to be blocked.";

		const blockListOptions = [
			{text: `Sender email: ${email.malicious.tpResults.resHead.from.senderMailFrom}`, model: this.actionForHeaders.senderEmail, value: email.malicious.tpResults.resHead.from.senderMailFrom, type: 'email', sender: true},
			{text: `Sender domain: ${this.gs.getDomain(email.sender)}`, model: this.actionForHeaders.senderDomain, value: this.gs.getDomain(email.sender), type: 'domain', warning: domainWarning},
			{text: `Reply-to email: ${email.malicious.tpResults.resHead.from.replyTo}`, model: this.actionForHeaders.replyToEmail, value: email.malicious.tpResults.resHead.from.replyTo, type: 'email'},
			{text: `Reply-to domain: ${this.gs.getDomain(email.malicious.tpResults.resHead.from.replyTo)}`, model: this.actionForHeaders.replyToDomain, value: this.gs.getDomain(email.malicious.tpResults.resHead.from.replyTo), type: 'domain', warning: domainWarning},
			{text: `Return path email: ${email.malicious.tpResults.resHead.from.returnPath}`, model: this.actionForHeaders.returnPathEmail, value: email.malicious.tpResults.resHead.from.returnPath, type: 'email'},
			{text: `Return path domain: ${this.gs.getDomain(email.malicious.tpResults.resHead.from.returnPath)}`, model: this.actionForHeaders.returnPath, value: this.gs.getDomain(email.malicious.tpResults.resHead.from.returnPath), type: 'domain', warning: domainWarning},
			{text: `MTA hostname: ${email.malicious.tpResults.resHead.from.sendingMTAFull}`, model: this.actionForHeaders.sendingMTA, value: email.malicious.tpResults.resHead.from.sendingMTAFull, type: 'mta'},
			{text: `MTA root domain: ${email.malicious.tpResults.resHead.from.sendingMTA?.domain}`, model: this.actionForHeaders.sendingMTADomain, value: email.malicious.tpResults.resHead.from.sendingMTA?.domain, type: 'mta'},
			{text: `Message-ID domain: ${this.gs.getDomain(email.malicious.tpResults.resHead.from.messageID)}`, model: this.actionForHeaders.messageID, value: this.gs.getDomain(email.malicious.tpResults.resHead.from.messageID), type: 'domain', warning: domainWarning},
		];
		if (email.malicious.tpResults.resHead.from.senderMail && email.malicious.tpResults.resHead.from.senderMail !== email.malicious.tpResults.resHead.from.senderMailFrom) {
			blockListOptions.unshift({text: `Sender appears as: ${email.malicious.tpResults.resHead.from.senderMail}`, model: this.actionForHeaders.senderEmailAppearsAs, value: email.malicious.tpResults.resHead.from.senderMail, type: 'email'});
		}
		if (email.malicious.tpResults.resHead.from && email.malicious.tpResults.resHead.from.ipAddresses && email.malicious.tpResults.resHead.from.ipAddresses.length) {
			email.malicious.tpResults.resHead.from.ipAddresses.forEach((ipAddr) => {
				this.actionForHeaders[ipAddr] = false;
				blockListOptions.push({text: `Sender IP address: ${ipAddr}`, model: this.actionForHeaders[ipAddr], value: ipAddr, type: 'ip'});
			});
		}

		this.blocklistSenderPopup = {
			show: true,
			items: blockListOptions,
			email: email,
			actionScope: this.planInfo?.allowGlobalAllowBlockLists ? 'global' : 'mailbox'
		};
	}

	addSenderBlacklistPopupExecute = (cb= (err?:any) => {}) => {
		this.actionInProcess = true;

		const items = this.blocklistSenderPopup.items.filter(itm => itm.model);
		items.forEach((itemObj) => {
			itemObj.description = this.blocklistSenderPopup.reason || '';
		});
		if (!items.length) {
			this.actionInProcess = false;
			this.ns.showErrorMessage('You must select at least one header');
			return;
		}

		let recipientMailboxes = [''];
		if (this.blocklistSenderPopup.actionScope === 'mailbox') {
			if (getCurrentMailbox(this.blocklistSenderPopup.email)) {
				recipientMailboxes = [getCurrentMailbox(this.blocklistSenderPopup.email)];
			}
			else {
				recipientMailboxes = [...this.blocklistSenderPopup.email.mailbox_email];
			}
		}

		recipientMailboxes.forEach((recipientMailbox, idx) => {
			this.addSenderBlackListExecute(this.blocklistSenderPopup.email, items, recipientMailbox, (err) => {
				this.actionInProcess = false;
				this.blocklistSenderPopup.show = false;
				this.actionFinished();

				const currentMsg = this.ns.getCurrentMessage();
				if (currentMsg && currentMsg.error) {
					this.popupError = currentMsg;
				}
				else {
					if (this.curEmail && this.curEmail.senderMethods) {
						_.remove<any>(this.curEmail.senderMethods, m => m === this.dic.CONSTANTS.quarantinedActions.blacklist.value);
						this.curEmail.senderMethods.push(this.dic.CONSTANTS.quarantinedActions.whitelist.value);
					}
					this.popupError = null;
					this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, 'sender'));
				}

				if (idx === recipientMailboxes.length - 1) {
					cb(err);
				}
			});
		});
	}

	addSenderBlackListExecute = (email, items, mailboxEmail, cb) => {
		if (mailboxEmail) {
			const userConfigData = {type: this.dic.CONSTANTS.quarantinedActions.blacklist.value, action: 'Add', items, userEmail: mailboxEmail};
			this.rs.updateTpConfigUsers(userConfigData).then((response) => {
				this.addReviewerAction(email, response && response.reviewerActivity);
				cb();
			}, err => {
				this.popupError = this.ns.getCurrentMessage();
				cb(err);
			});
		}
		else {
			const planConfigData = {
				action: this.dic.CONSTANTS.quarantinedActions.blacklist.value,
				items: items
			};
			const emailId = getEmailId(email);
			this.rs.doActionOnQuarantinedEmail(emailId, planConfigData, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
				this.addReviewerAction(email, response.reviewerActivity);
				cb();
			}, err => {
				this.popupError = this.ns.getCurrentMessage();
				cb(err);
			});
		}
	}

	addLinksWhitelistPopup = (email) => {
		this.allowlistLinksPopup = {
			show: true,
			actionScope: this.planInfo?.allowGlobalAllowBlockLists ? 'global' : 'mailbox',
			doneCb: () => {
				this.loadQuarantineData = true;

				const data: any = {
					action: this.dic.CONSTANTS.quarantinedActions.linksWhitelist.value,
					links: []
				};
				email.malicious.tpResults.resUrl.list.forEach((linkObj) => {
					if (linkObj.status !== "Safe") {
						data.links.push({link: linkObj.url});
					}
				});

				if (this.allowlistLinksPopup.actionScope === 'mailbox') {
					data.userEmail = getCurrentMailbox(email);
					data.type = this.dic.CONSTANTS.quarantinedActions.linksWhitelist.value;
					data.action = 'Add';
					this.rs.updateTpConfigUsers(data).then((response) => {
						this.addReviewerAction(email, response?.reviewerActivity);
						this.loadQuarantineData = false;
						this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, 'Links'));
						this.allowlistLinksPopup = null;
						this.actionFinished();
					}, err => {
						this.popupError = this.ns.getCurrentMessage();
					});
				}
				else {
					const emailId = getEmailId(email);
					this.rs.doActionOnQuarantinedEmail(emailId, data, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
						this.addReviewerAction(email, response.reviewerActivity);
						this.loadQuarantineData = false;
						this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, 'Links'));
						this.allowlistLinksPopup = null;
						this.actionFinished();
					}, err => {
						this.popupError = this.ns.getCurrentMessage();
					});
				}
			}
		};
	}

	// per-row security reviewer action targets: the row value and, for emails / hostnames, its domain
	rowTargets = (row: string, value: any, rootDomain?: string) => {
		const targets = [];
		const add = (label: string, targetValue: string, type: string, sender = false) => {
			if (!targetValue) {
				return;
			}
			const data: any = {value: targetValue, type};
			if (sender) {
				data.sender = true;
			}
			// CC: the backend global "trust" only removes blocklisted identities (email / mta), it cannot undo a global domain / IP block
			targets.push({label, value: targetValue, data, noGlobalAllow: type === 'domain' || type === 'ip'});
		};
		const targetLabels = this.dic.CONSTANTS.srRowAction.targetLabels;
		// a domain under a subdomain is offered twice: the full host (Subdomain) and its root domain
		const addDomainTargets = (domain: string) => {
			const domainRoot = this.gs.getRootDomain(domain);
			add(domainRoot ? targetLabels.subdomain : targetLabels.domain, domain, 'domain');
			add(targetLabels.rootDomain, domainRoot, 'domain');
		};

		switch (row) {
			case 'sender':
			case 'email':
				add(targetLabels.email, value, 'email', row === 'sender');
				addDomainTargets(this.gs.getDomain(value));
				break;

			case 'messageId':
				addDomainTargets((this.gs.getDomain(value) || '').replace(/[<>]/g, ''));
				break;

			case 'mta':
				// CC: an MTA that is a raw IP has no root domain (it would just drop the first octet) - act on it as an MTA identity or as an IP (same as the IP addresses row)
				if (this.dic.CONSTANTS.IP_REGEX.test(value)) {
					add(targetLabels.mta, value, 'mta');
					add(targetLabels.ip, value, 'ip');
					break;
				}
				add(targetLabels.hostname, value, 'mta');
				add(targetLabels.rootDomain, rootDomain, 'mta');
				break;

			case 'ip':
				(value || []).forEach((ip) => {
					add(ip, ip, 'ip');
				});
				break;
		}

		return targets;
	}

	// per-row security reviewer action (sender identity / link / attachment): global for all plans, or the plan sender lists
	doRowAction = (event, kind: string) => {
		const email = this.curEmail;
		if (event.scope === 'plan') {
			const execute = event.block ? this.addSenderBlackListExecute : this.addSenderWhiteListExecute;
			execute(email, [{...event.target.data, description: ''}], '', (err) => {
				event.done();
				if (err) {
					return;
				}
				// same sender buttons state as the plan blocklist / allowlist popups
				if (this.curEmail?.senderMethods) {
					const [doneMethod, otherMethod] = event.block
						? [this.dic.CONSTANTS.quarantinedActions.blacklist.value, this.dic.CONSTANTS.quarantinedActions.whitelist.value]
						: [this.dic.CONSTANTS.quarantinedActions.whitelist.value, this.dic.CONSTANTS.quarantinedActions.blacklist.value];
					_.remove<any>(this.curEmail.senderMethods, m => m === doneMethod);
					if (!this.curEmail.senderMethods.includes(otherMethod)) {
						this.curEmail.senderMethods.push(otherMethod);
					}
				}
				this.popupError = null;
				this.ns.showInfoMessage(this.dic.MESSAGES.operationCompleted);
			});
			return;
		}

		const actions = {
			sender: this.dic.CONSTANTS.quarantinedActions.securityReviewerGlobalSender.value,
			links: this.dic.CONSTANTS.quarantinedActions.securityReviewerGlobalLinks.value,
			attachments: this.dic.CONSTANTS.quarantinedActions.securityReviewerGlobalAttachment.value
		};
		const data: any = {
			action: actions[kind],
			type: event.block ? 'report' : 'trust'
		};
		if (kind === 'sender') {
			data.items = [event.target.data];
		}
		else if (kind === 'links') {
			data.links = [event.target.value];
		}
		else {
			data.attachments = [event.target.data];
		}

		this.rs.doActionOnQuarantinedEmail(getEmailId(email), data, this.getPlanIdParamsForQuarantineAction(email)).then(() => {
			event.done();
			this.popupError = null;
			this.ns.showInfoMessage(this.dic.MESSAGES.operationCompleted);
		}, () => {
			event.done();
			this.popupError = this.ns.getCurrentMessage();
		});
	}

	createIncidentPopup = (email) => {
		this.incidentPopup = {
			show: true,
			securityTeamComments: 'We were unable to determine whether this quarantined email is legitimate based on security signals alone. Please confirm if you recognize the sender and whether the email should be released.',
			suggestedSecurityTeamComments: '',
			generateInProcess: false,
			addUserNotification: false,
			applyInProcess: false,
			email: email,
			doneCb: () => {
				this.incidentPopup.applyInProcess = true;
				this.loadQuarantineData = true;

				const data = {
					action: this.dic.CONSTANTS.quarantinedActions.createIncident.value,
					securityTeamComments: this.incidentPopup.securityTeamComments,
					addUserNotification: this.incidentPopup.addUserNotification
				};

				const emailId = getEmailId(email);
				this.rs.doActionOnQuarantinedEmail(emailId, data, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
					this.addReviewerAction(email, response.reviewerActivity);
					email.mark_follow = true;
					this.loadQuarantineData = false;
					this.ns.showInfoMessage(`Incident created successfully`);
					this.incidentPopup.applyInProcess = false;
					this.incidentPopup.show = false;
					this.actionFinished();
				}, (err) => {
					this.popupError = this.ns.getCurrentMessage();
					this.incidentPopup.applyInProcess = false;
					this.loadQuarantineData = false;
				});
			}
		};
	}

	generateIncidentNote = () => {
		if (!this.incidentPopup?.email) {
			return;
		}

		const data = {
			action: this.dic.CONSTANTS.quarantinedActions.generateIncidentNote.value,
			securityTeamComments: this.incidentPopup.securityTeamComments,
			addUserNotification: this.incidentPopup.addUserNotification
		};

		const emailId = getEmailId(this.incidentPopup.email);
		this.incidentPopup.generateInProcess = true;
		this.rs.doActionOnQuarantinedEmail(emailId, data, this.getPlanIdParamsForQuarantineAction(this.incidentPopup.email)).then((response) => {
			this.incidentPopup.suggestedSecurityTeamComments = response && response.securityTeamComments || '';
			this.incidentPopup.securityTeamComments = this.incidentPopup.suggestedSecurityTeamComments;
			this.incidentPopup.generateInProcess = false;
		}, () => {
			this.incidentPopup.generateInProcess = false;
		});
	}

	createSecurityReviewerActivityPopup = (email) => {
		const emdrActions = [];
		for (let key in this.dic.CONSTANTS.emdrActionType) {
			emdrActions.push({name: key, selected: key === this.dic.CONSTANTS.emdrActionType.action});
		}
		this.securityReviewerPopup = {
			show: true,
			applyInProcess: false,
			securityTeamCommentInput: this.securityTeamComments,
			addUserNotification: false,
			emdrActionInput: {
				model: emdrActions[0].name,
				selected: emdrActions[0].selected
			},
			dropdownObjects: emdrActions,
			doneCb: () => {
				this.securityReviewerPopup.applyInProcess = true;
				if (!this.securityReviewerPopup.securityTeamCommentInput || this.securityReviewerPopup.dropdownObjects[0].selected === this.securityReviewerPopup.dropdownObjects[1].selected) {
					this.ns.showErrorMessage(`You must add description and select only one type of activity`);
					this.securityReviewerPopup.applyInProcess = false;
					return;
				}
				this.loadQuarantineData = true;

				const data = {
					action: this.dic.CONSTANTS.quarantinedActions.securityReviewerActivity.value,
					securityTeamComments: this.securityReviewerPopup.securityTeamCommentInput,
					addUserNotification: this.securityReviewerPopup.addUserNotification,
					type: this.securityReviewerPopup.emdrActionInput.model
				};

				const emailId = getEmailId(email);
				this.rs.doActionOnQuarantinedEmail(emailId, data, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
					this.addReviewerAction(email, 'Reviewer Activity: ' + data.securityTeamComments);
					this.loadQuarantineData = false;
					this.ns.showInfoMessage(`Activity added successfully`);
					this.securityReviewerPopup.applyInProcess = false;
					this.securityReviewerPopup.show = false;
					this.actionFinished();
				}, (err) => {
					this.popupError = this.ns.getCurrentMessage();
					this.securityReviewerPopup.applyInProcess = false;
					this.loadQuarantineData = false;
				});
			}
		};
	}

	showOpenAiClassifyEmailPopup = (email) => {
		this.openAiClassifyEmailPopup = {
			embeddedNew: false,
			embeddedProd: false,
			finetuneNew: false,
			finetuneProd: false,
			baselineNew: false,
			baselineProd: false,
			fallbackProd: false,
			hybridNew: false,
			hybridProd: false,
			email: email,
			show: true,
			results: ''
		};
		this.openAiClassifyEmailPopup[DEFAULT_AI_RESCAN] = true;
	}

	setModelOpenAiClassifyEmailPopup(model) {
		this.openAiClassifyEmailPopup.embeddedNew = false;
		this.openAiClassifyEmailPopup.embeddedProd = false;
		this.openAiClassifyEmailPopup.finetuneNew = false;
		this.openAiClassifyEmailPopup.finetuneProd = false;
		this.openAiClassifyEmailPopup.baselineNew = false;
		this.openAiClassifyEmailPopup.baselineProd = false;
		this.openAiClassifyEmailPopup.fallbackProd = false;
		this.openAiClassifyEmailPopup.hybridNew = false;
		this.openAiClassifyEmailPopup.hybridProd = false;

		if (model) {
			this.openAiClassifyEmailPopup[model] = true;
		}
	}

	openAiClassifyEmailPopupExecute() {
		this.openAiClassifyEmailPopup.results = '';

		const email = this.openAiClassifyEmailPopup.email;
		const data = {
			action: this.dic.CONSTANTS.quarantinedActions.classifyEmail.value,
			embedded: this.openAiClassifyEmailPopup.embeddedNew || this.openAiClassifyEmailPopup.embeddedProd,
			finetune: this.openAiClassifyEmailPopup.finetuneNew || this.openAiClassifyEmailPopup.finetuneProd,
			baseline: this.openAiClassifyEmailPopup.baselineNew || this.openAiClassifyEmailPopup.baselineProd,
			fallback: this.openAiClassifyEmailPopup.fallbackProd,
			hybrid: this.openAiClassifyEmailPopup.hybridNew || this.openAiClassifyEmailPopup.hybridProd,
			newVersion: this.openAiClassifyEmailPopup.embeddedNew || this.openAiClassifyEmailPopup.finetuneNew || this.openAiClassifyEmailPopup.baselineNew || this.openAiClassifyEmailPopup.hybridNew
		};

		this.openAiClassifyEmailPopup.actionInProcess = true;
		const emailId = getEmailId(email);
		this.doActionOnQuarantinedEmailRetry(emailId, data, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
			this.openAiClassifyEmailPopup.results = response.meta && response.meta.message || '';
			this.openAiClassifyEmailPopup.actionInProcess = false;
		}, err => {
			this.openAiClassifyEmailPopup.actionInProcess = false;
			this.popupError = this.ns.getCurrentMessage();
		});
	}

	AIanalysisAction = (email) => {
		email.getAiAnalysisInProcess = true;
		const data:any = {action: this.dic.CONSTANTS.quarantinedActions.AIanalysis.value};
		const emailId = getEmailId(email);
		this.rs.doHeavyActionOnQuarantinedEmail(emailId, data, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
			if (!email.getAiAnalysisInProcess || this.curEmail !== email) {
				return;
			}
			email.aiAnalysisData = response;
			email.showAiAnalysis = true;
			email.getAiAnalysisInProcess = false;
		}, err => {
			this.popupError = this.ns.getCurrentMessage();
			email.getAiAnalysisInProcess = false;
		});
	}

	saveEmailToOpenAiDataset(email, className) {
		const data = {
			action: this.dic.CONSTANTS.quarantinedActions.saveRecord.value,
			class: className.toLowerCase()
		};

		email.openAiDatasetInProcess = true;
		this.doActionOnQuarantinedEmailRetry(getEmailId(email), data, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
			email.openAiDatasetInProcess = false;
			email.openAiDatasetPending = null;
			email.openAiDatasetSaved = _.union(email.openAiDatasetSaved || [], [className]);
			this.ns.showInfoMessage(util.format(this.dic.MESSAGES.savedToOpenAiDataset, className));
		}, err => {
			this.popupError = this.ns.getCurrentMessage();
			email.openAiDatasetInProcess = false;
		});
	}

	openThreatSimulationTemplatePopup = (email) => {
		this.threatSimulationPopup = {
			name: '',
			description: '',
			linksList: this.curTPResults.resUrl?.list?.map(({ icon, ...rest }) => rest),
			selectedLink: '',
			isCompleted: false,
			applyInProcess: false,
			show: true,

			doneCb: () => {
				if (this.threatSimulationPopup.applyInProcess) {
					return;
				}
				if (this.threatSimulationPopup.isCompleted) {
					this.threatSimulationPopup = null;
					this.actionFinished();
					return;
				}

				if (!this.threatSimulationPopup.name.trim()) {
					this.ns.showWarnMessage(util.format(this.dic.ERRORS.cannotBeEmpty, 'Name'));
					return;
				}
				if (!this.threatSimulationPopup.description.trim()) {
					this.ns.showWarnMessage(util.format(this.dic.ERRORS.cannotBeEmpty, 'Description'));
					return;
				}

				this.threatSimulationPopup.applyInProcess = true;

				const data = {
					action: this.dic.CONSTANTS.quarantinedActions.threatSimulationTemplate.value,
					name: this.threatSimulationPopup.name.trim(),
					link: this.threatSimulationPopup.selectedLink?.original_url,
					description: this.threatSimulationPopup.description.trim(),
				};

				const emailId = getEmailId(email);
				this.rs.doHeavyActionOnQuarantinedEmail(emailId, data, this.getPlanIdParamsForQuarantineAction(email)).then((response) => {
					this.threatSimulationPopup.isCompleted = true;
					this.threatSimulationPopup.applyInProcess = false;
					this.addReviewerAction(email, response.reviewerActivity);
				}, err => {
					this.threatSimulationPopup.applyInProcess = false;
				});
			}
		};
	}

	openAiTrainingMaterialPopup = (email) => {
		const emailSubject = email.subject?.trim() || 'Untitled Email';
		const emailStatus = (email.malicious?.status || email.category || 'Suspicious').toString().toLowerCase();

		this.aiTrainingMaterialPopup = {
			show: true,
			error: false,
			captureInProcess: true,
			addMaterialsInProcess: false,
			previewHtml: '',
			email,
			data: {
				title: `How to identify ${emailStatus} for: ${emailSubject}`,
				description: `Create a security awareness training video based on the attached email content. Focus on how to detect and avoid this ${emailStatus} email, highlight key indicators (sender, subject, language, links/attachments), and provide best practices for users.`.trim(),
				botGender: 'Female',
				audience: this.aiTrainingAudienceOptions[0],
				videoLength: 1,
				files: [],
			},
		};

		this.previewQuarantinedEmailContent(email, 2, (err) => {
			if (!this.aiTrainingMaterialPopup) {
				return;
			}

			if (err) {
				this.aiTrainingMaterialPopup.captureInProcess = false;
				this.ns.showWarnMessage('Unable to load email content for AI training.');
			}
			this.aiTrainingMaterialPopup.previewHtml = this.buildAiTrainingPreviewHtml(email);
		});
	}

	buildAiTrainingPreviewHtml(email) {
		const contentHtml = email.content?.html ? email.content.html : `<pre>${this.escapeAiTrainingHtml(email.content?.text || '')}</pre>`;
		return `<!doctype html>
<html>
	<head>
		<meta charset="utf-8">
		<style>
			body { margin: 0; padding: 16px; font-family: Arial, sans-serif; background: #ffffff; color: #111; }
			img { max-width: 100%; height: auto; }
			table { max-width: 100%; }
			* { box-sizing: border-box; }
		</style>
	</head>
	<body>${contentHtml}</body>
</html>`;
	}

	escapeAiTrainingHtml(text) {
		return text.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}

	captureAiTrainingScreenshot = () => {
		if (!this.aiTrainingMaterialPopup?.show) {
			return;
		}
		const iframe: HTMLIFrameElement = this.aiTrainingPreviewIframe?.nativeElement;
		const iframeDoc = iframe?.contentDocument || iframe?.contentWindow?.document;
		if (!iframeDoc?.body) {
			this.aiTrainingMaterialPopup.captureInProcess = false;
			return;
		}

		const docElement = iframeDoc.documentElement;
		const captureWidth = docElement.scrollWidth || iframe.clientWidth || 800;
		const captureHeight = docElement.scrollHeight || iframe.clientHeight || 600;
		iframe.style.width = `${captureWidth}px`;
		iframe.style.height = `${captureHeight}px`;

		html2canvas(iframeDoc.body, {
			backgroundColor: '#ffffff',
			scale: 2,
			useCORS: true,
			allowTaint: true,
			width: captureWidth,
			height: captureHeight,
			windowWidth: captureWidth,
			windowHeight: captureHeight,
		}).then((canvas) => {
			const dataUrl = canvas.toDataURL('image/png');
			const file = this.convertDataUrlToFile(dataUrl, `email-content-${getEmailId(this.aiTrainingMaterialPopup.email)}.png`);
			this.aiTrainingMaterialPopup.data.files = [{
				fileData: file,
				description: 'Use the rendered screenshot of the quarantined email content to explain on it about the threat and how to detect it.',
				previewBase64: dataUrl.split(',')[1],
			}];
			this.aiTrainingMaterialPopup.captureInProcess = false;
		}).catch(() => {
			this.aiTrainingMaterialPopup.captureInProcess = false;
			this.ns.showWarnMessage('Unable to capture the email content screenshot.');
		});
	}

	convertDataUrlToFile(dataUrl, filename): File {
		const [header, base64] = dataUrl.split(',');
		const mimeMatch = header.match(/:(.*?);/);
		const mime = mimeMatch ? mimeMatch[1] : 'image/png';
		const binary = atob(base64);
		const len = binary.length;
		const bytes = new Uint8Array(len);
		for (let i = 0; i < len; i++) {
			bytes[i] = binary.charCodeAt(i);
		}
		return new File([bytes], filename, {type: mime});
	}

	generateAiTrainingMaterial = () => {
		if (!this.aiTrainingMaterialPopup || this.aiTrainingMaterialPopup.addMaterialsInProcess) {
			return;
		}

		if (!this.aiTrainingMaterialPopup.data.title.trim()) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.cannotBeEmpty, 'Title'));
			this.aiTrainingMaterialPopup.error = true;
			return;
		}

		if (!this.aiTrainingMaterialPopup.data.description.trim()) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.cannotBeEmpty, 'Video content'));
			this.aiTrainingMaterialPopup.error = true;
			return;
		}

		if (!this.aiTrainingMaterialPopup.data.files?.length) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.cannotBeEmpty, 'Media'));
			this.aiTrainingMaterialPopup.error = true;
			return;
		}

		if (this.aiTrainingMaterialPopup.data.files.some(file => !file.description.trim())) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.cannotBeEmpty, 'Media file description'));
			this.aiTrainingMaterialPopup.error = true;
			return;
		}

		if (!this.aiTrainingMaterialPopup.data.audience) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.noSelected, 'audience'));
			this.aiTrainingMaterialPopup.error = true;
			return;
		}

		const data = {
			title: this.aiTrainingMaterialPopup.data.title.trim(),
			desc: this.aiTrainingMaterialPopup.data.description.trim(),
			audience: this.aiTrainingMaterialPopup.data.audience,
			videoLength: this.aiTrainingMaterialPopup.data.videoLength,
			botGender: this.aiTrainingMaterialPopup.data.botGender,
		};

		const formData = new FormData();
		for (const [key, value] of Object.entries(data) as any) {
			formData.append(key, value);
		}

		this.aiTrainingMaterialPopup.data.files.forEach((file) => {
			formData.append('file[]', file.fileData);
			formData.append('fileDesc[]', file.description);
		});

		this.aiTrainingMaterialPopup.addMaterialsInProcess = true;

		this.http.post(ENV_CONSTS.attachmentUrl + '/admin/threatSimulation/material/ai', formData, {headers: this.authService.getHeaders()})
			.subscribe(() => {
				this.aiTrainingMaterialPopup = null;
				this.actionFinished();
				this.ns.showInfoMessage(this.dic.MESSAGES.aiCreateVideoSuccess);
			}, (errEvent) => {
				this.aiTrainingMaterialPopup.addMaterialsInProcess = false;
				this.ns.showErrorMessage(errEvent.error?.message || 'Failed to generate AI training material.');
			});
	}

	openClickTrackingPopup = (url) => {
		this.urlTrackingPopup = {
			urlAddress: url.redirect_url || url.url,
			clickInfo: url.clickInfo,
			show: true
		};
	}

	openLocation = (ll) => {
		this.gs.openLocation(ll);
	}

	openRescanLinkPopup = (url) => {
		if (url.rescanLinkInProcess) {
			return;
		}

		this.gs.showPopup({
			title: 'Rescan Link',
			subTitle: "The process will rescan the URL and update the results in the Threat Analysis section. Allow/Block lists will be ignored.",
			doneBtnText: 'Confirm',
			type: this.dic.CONSTANTS.popupInfo,
			doneCb: () => {
				url.rescanLinkInProcess = true;

				const data:any = {
					action: this.dic.CONSTANTS.quarantinedActions.rescanLink.value,
					url: url.url
				};
				const emailId = getEmailId(this.curEmail);
				this.rs.doHeavyActionOnQuarantinedEmail(emailId, data, this.getPlanIdParamsForQuarantineAction(this.curEmail)).then((response) => {
					url.rescanLinkInProcess = false;
					this.checkViewThreatsReScanStatus(this.curEmail, 0);
				}, err => {
					url.rescanLinkInProcess = false;
				});
			}
		});
	}

	openRescanFilePopup = (file) => {
		if (file.rescanFileInProcess) {
			return;
		}

		this.gs.showPopup({
			title: 'Rescan File',
			subTitle: 'The process will rescan the file and update the results in the Threat Analysis section. Allow/Block lists will be ignored.',
			doneBtnText: 'Confirm',
			type: this.dic.CONSTANTS.popupInfo,
			doneCb: () => {
				file.rescanFileInProcess = true;
				const data:any = {
					action: this.dic.CONSTANTS.quarantinedActions.rescanFile.value,
					fileHash: file.hash,
				};
				const emailId = getEmailId(this.curEmail);
				this.doActionOnQuarantinedEmailRetry(emailId, data, this.getPlanIdParamsForQuarantineAction(this.curEmail)).then((response) => {
					file.rescanFileInProcess = false;
					this.checkViewThreatsReScanStatus(this.curEmail, 0);
				}, err => {
					file.rescanLinkInProcess = false;
				});
			}
		});
	}

	showRelationshipConnectionGraph = () => {
		const data = {
			sender: this.curTPResults.resHead.from.senderMailFrom
		};

		this.senderConnectionGraphPopup = {
			rawData: null,
			graphData: [],
			nodeOptionsFn: (node, allLinks) => {
				node.color = _.find(allLinks, {target: node.name}) ? 'green' : '';
			},
			nodeSearchTxt: '',
			nodeSearchResults: null,
			scope: '',
			show: true,
			loading: true
		};

		this.rs.getSenderConnectionGraphData(data).then(response => {
			this.senderConnectionGraphPopup.loading = false;
			response = _.reject(response, contact => contact.email === contact.user_email);
			this.senderConnectionGraphPopup.rawData = response;

			setTimeout(() => {
				this.updateConnectionGraphScope('sender');
			});
		}, err => {
			this.senderConnectionGraphPopup.loading = false;
		});
	}

	updateConnectionGraphScope = (scope) => {
		this.senderConnectionGraphPopup.scope = scope;

		let data;
		if (scope === 'sender') {
			data = _.filter(this.senderConnectionGraphPopup.rawData, {email: this.curTPResults.resHead.from.senderMailFrom});
		}
		else {
			data = this.senderConnectionGraphPopup.rawData;
		}

		if (!data?.length) {
			this.senderConnectionGraphPopup.graphData = null;
			return;
		}

		this.senderConnectionGraphPopup.graphData = {
			links: _.map(data, contact => ({source: contact.email, target: contact.user_email})),
		};
	}

	searchConnectionEmailAddress = () => {
		let data;
		if (this.senderConnectionGraphPopup.scope === 'sender') {
			data = _.filter(this.senderConnectionGraphPopup.rawData, {email: this.curTPResults.resHead.from.senderMailFrom});
		}
		else {
			data = this.senderConnectionGraphPopup.rawData;
		}

		if (this.senderConnectionGraphPopup.nodeSearchTxt && data?.length) {
			this.senderConnectionGraphPopup.nodeSearchResults = [];

			data.forEach(contact => {
				if (contact.email.includes(this.senderConnectionGraphPopup.nodeSearchTxt)) {
					this.senderConnectionGraphPopup.nodeSearchResults.push(contact.email);
				}
				if (contact.user_email.includes(this.senderConnectionGraphPopup.nodeSearchTxt)) {
					this.senderConnectionGraphPopup.nodeSearchResults.push(contact.user_email);
				}
			});

			this.senderConnectionGraphPopup.nodeSearchResults = _.union(this.senderConnectionGraphPopup.nodeSearchResults);
		}
		else {
			this.senderConnectionGraphPopup.nodeSearchResults = null;
		}
	}

	setEmailCategory = (email) => {
		if (email.malicious) {
			if (email.malicious.status_user_reported) {
				this.setEmailCategoryExecute(email, email.malicious.status_user_reported);
			}
			else {
				this.setEmailCategoryExecute(email, email.malicious.status);
			}
		}
	}

	setEmailCategoryExecute = (email, status) => {
		if (!email || !status) {
			return;
		}
		email.category = status;
		switch (status.toLowerCase()) {
			case this.dic.CONSTANTS.tpRule.name.malicious:
				email.color = 'darkred';
				email.category_priority = 1;
				break;
			case this.dic.CONSTANTS.tpRule.name.suspicious:
				email.color = 'darkred';
				email.category_priority = 2;
				break;
			case this.dic.CONSTANTS.tpRule.name.spam:
				email.color = 'darkorange';
				email.category_priority = 3;
				break;
			case this.dic.CONSTANTS.tpRule.name.graymail:
				email.color = 'dimgray';
				email.category_priority = 4;
				break;
			case this.dic.CONSTANTS.tpRule.name.external:
				email.color = 'darkorange';
				email.category_priority = 5;
				break;
			default:
				email.color = 'darkgreen';
				email.category_priority = 6;
		}
	}

	searchHeader = () => {
		this.curEmail?.headers?.forEach(headerObj => {
			if (this.headerSearchTerm) {
				const isFound = searchHeadersExecute(headerObj, this.headerSearchTerm);
				if (!isFound) {
					headerObj.hide = true;
					return;
				}
			}
			headerObj.hide = false;
		});
	}

	searchReviewer = () => {
		this.curEmail?.reviewer_actions?.forEach(actionObj => {
			if (this.reviewerSearchTerm) {
				const isFound = searchReviewersExecute(actionObj, this.reviewerSearchTerm);
				if (!isFound) {
					actionObj.hide = true;
					return;
				}
			}
			actionObj.hide = false;
		});
	}

	getEmailTrace = () => {
		if (!this.curEmail?.message_id || this.curEmail.loadingEmailTrace
			|| !this.curEmail.showEmailTraceSection) {
			return;
		}

		const rcptTo = getCurrentMailbox(this.curEmail);
		if (!rcptTo) {
			return;
		}
		const emailObj = this.curEmail.parent && this.curEmail.emails?.length ? this.curEmail.emails.find(itm => itm.mailbox_email === rcptTo) : this.curEmail;
		if (!emailObj) {
			return;
		}

		this.curEmail.loadingEmailTrace = true;

		const queryData = {
			period: this.dic.CONSTANTS.trendsPeriod.lastMonth.value,
			message_id: emailObj.message_id,
			direction: 'inbound',
			rcptTo: rcptTo
		};

		this.rs.getEmailTracingLog(queryData).then(data => {
			this.curEmail.emailTraceLogs = data?.logs?.map(itm => {
				return {...itm._source, _id: itm._id};
			}) || [];
			this.curEmail.emailTraceLoaded = true;
			this.curEmail.loadingEmailTrace = false;
		}, () => {
			this.curEmail.loadingEmailTrace = false;
		});
	}

	doActionOnQuarantinedEmailRetry(quarantinedId, data, params, counter=2) {
		const heavyActions = [
			this.dic.CONSTANTS.quarantinedActions.rescanFile.value,
			this.dic.CONSTANTS.quarantinedActions.classifyEmail.value,
			this.dic.CONSTANTS.quarantinedActions.saveRecord.value
		];

		const doActionOnQuarantinedEmail = heavyActions.includes(data.action) ?
			this.rs.doHeavyActionOnQuarantinedEmail :
			this.rs.doActionOnQuarantinedEmail;

		return doActionOnQuarantinedEmail(quarantinedId, data, params).catch(err => {
			if (err.data?.message && !err.data?.display_bar) {
				this.ns.showErrorMessage(err.data?.message);
			}
			if (err.data?.retry && counter > 0) {
				return new Promise(resolve => setTimeout(resolve, 1000))
					.then(() => this.doActionOnQuarantinedEmailRetry(quarantinedId, data, params, --counter));
			}

			return Promise.reject(err);
		});
	}

	protected readonly moment = moment;
}


function getFirstVisibleChild(email) {
	return email.emails.find(childEmail => !childEmail.hide) || email.emails[0];
}

function getEmailId(email) {
	return email.parent ? getFirstVisibleChild(email)._id : email._id;
}

// CC: a parent group can hold emails of several plans, so the plan must come from the same record getEmailId takes the id from
function getEmailPlanId(email) {
	return email.parent ? getFirstVisibleChild(email).plan_id : email.plan_id;
}

function getCurrentMailbox(emailObj) {
	if (emailObj.parent && emailObj.emails.length) {
		return emailObj.curRecipient?.mailbox_email || getFirstVisibleChild(emailObj).mailbox_email;
	}
	else {
		return emailObj.mailbox_email.toString();
	}
}

function searchHeadersExecute(obj, searchTerm) {
	searchTerm = searchTerm.toLowerCase();
	return ((obj.name?.toLowerCase().indexOf(searchTerm) > -1) ||
		((obj.key?.toLowerCase().indexOf(searchTerm) > -1)) ||
		(obj.value?.toLowerCase().indexOf(searchTerm) > -1));
}

function searchReviewersExecute(obj, searchTerm) {
	searchTerm = searchTerm.toLowerCase();
	return ((obj.reviewer?.toLowerCase().indexOf(searchTerm) > -1) ||
		(obj.action?.toLowerCase().indexOf(searchTerm) > -1));
}
